<template>
  <div class="bg-gray-50  pr-6">
    <div class="hidden  mt-2">
      <h4 class="text-left mb-2 text-xl tracking-tight font-bold text-gray-600 ">datasource_id = {{ datasource_id }}</h4>
    </div>

    <!-- Container des toasts -->
    <div class="fixed bottom-4 right-4 flex flex-col space-y-2 z-50">
      <transition-group name="toast">
        <div
          v-for="toast in toasts"
          :key="toast.id"
          :class="toast.type === 'success' ? 'bg-green-500' : 'bg-red-500'"
          class="flex items-center w-auto max-w-lg p-4 text-white rounded-lg shadow-lg transition-opacity"
        >
          <svg v-if="toast.type === 'success'" class="w-6 h-6 mr-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
          </svg>

          <svg v-if="toast.type === 'error'" class="w-6 h-6 mr-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>

          <span class="pr-2">{{ toast.message }}</span>

          <button @click="removeToast(toast.id)" class="ml-auto focus:outline-none">
            <svg class="w-5 h-5 text-white hover:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
      </transition-group>
    </div>
  </div>

  <B4FForm
    class="pr-6 pl-1 bg-gray-50"
    :record="record"
    :template="template"
    :countries="countries"
    :currentTab="current_tab"
    :custom-action="customAction"
    :title="displayTitle()"
    :subtitle="displaySubTitle()"
    @generate="OnGenerateSheet"
    @generate-pdf="onGeneratePDFReport"
    @change-field-parameter="changeFieldParameter"
    @display="OnDisplaySheet"
    @change-view="onChangeView"
    @manage-button-click="manageButtonClick"
    @manage-field="modalFieldOpen"
    @add-field="modalAddFieldOpen"
    @delete-field="onDeleteField"
    @save="onSave"
    @delete="onDelete"
    @cancel="onCancel"
    @select-image-modal-open="onSelectImageModalOpen"
    @manage-postal-address="modalPostalAddressOpen"
    @value-changed="onValueChanged"
    @action="onAction"
    @menuselected="onMenuSelected"
  />

  <SelectImageModal :current-in="currentImageIndex" @close="OnSelectImageModalClose" @select-image="onSelectImage" @add-image="OnAddImage" @change-root="onChangeRoot" />
  <GenerateSheetModal @close="OnGenerateSheetClose" @generate="OnGenerateSheetGenerate" @confirm="OnGenerateSheetConfirm" />
  <ModalField :config="empty" @close="modalFieldClose" @save="modalFieldSave" @delete="modalFieldDelete" />
  <PostalAddressModal :input="inputAddress" @close="OnPostalAddressClose" @confirm="OnPostalAddressConfirm" />
  <SupplierModal :input="inputSupplier" @close="OnSupplierClose" @confirm="OnSupplierConfirm" />
  <AttributModal :input="inputAttribut" @close="OnAttributClose" @confirm="OnAttributConfirm" />

  <HuntingBatchModal :input="inputHuntingBatch" @close="OnHuntingBatchClose" @confirm="OnHuntingBatchConfirm" />

  <WildGameEditModal :input="inputWildGameEdit" @close="OnWildGameEditCancel" @confirm="OnWildGameEditConfirm" />
  <WildGameMoveModal :input="inputWildGameMove" @close="OnWildGameMoveCancel" @confirm="OnWildGameMoveConfirm" />

  <HunterChangeModal :input="inputHunterChange" @close="OnHunterChangeCancel" @confirm="OnHunterChangeConfirm" />
  <ItemDeleteModal :input="inputItemDelete" @close="OnItemDeleteCancel" @confirm="OnItemDeleteConfirm" />
  <SendMailModal :input="sendMailDelete" @close="OnSendMailCancel" @confirm="OnSendMailConfirm" />

  <BatchNumberChangeModal :input="inputBatchReportUpdate" @close="OnBatchReportUpdateCancel" @confirm="OnBatchReportUpdateConfirm" />

  <BatchNumberChangeModal2 :input="inputBatchNumberUpdate" @close="OnBatchNumberNumberCancel" @confirm="OnBatchNumberNumberConfirm" />

  <DeliveryNumberChangeModal :input="inputDeliveryNumberUpdate" @close="OnDeliveryNumberNumberCancel" @confirm="OnDeliveryNumberNumberConfirm" />

  <VetoControlMoveModal :input="inputVetoControlMove" @close="OnVetoControlMoveCancel" @confirm="OnVetoControlMoveConfirm" :refresh="refresh_veto" />

  <ContactManagementModal :input="inputContact" @close="OnContactManagementClose" @confirm="OnContactManagementConfirm" />

  <DeleteDiagramModal :input="recordDelete" @close="OnClickDeleteCancel" @confirm="OnClickDeleteConfirm" />

  <PurchaseItemModal :input="inputPurchaseItemAdd" @close="OnClickPurchaseItemCancel" @confirm="OnClickPurchaseItemConfirm" />

  <DeliveryReportModal :input="inputDeliveryReport" @close="OnClickDeliveryReportCancel" @confirm="OnClickDeliveryReportConfirm" />

  <PickupReportModal :input="inputPickupReport" @close="OnClickPickupReportCancel" @confirm="OnClickPickupReportConfirm" />

  <SendMailsGeneratePdfModal :input="inputSendEmailsGeneratePdf" @close="OnClickSendMailsGeneratePdfCancel" @confirm="OnClickSendMailsGeneratePdfConfirm" />

  <CreateSectionModal :input="itemSection" @close="onOpenCloseSection" @validate="onOpenConfirmSection" :refresh="refresh" />
  <SelectRecipeStepModal :input="itemManufacturingStep" @close="onCloseManufacturingProcessStep" @confirm="onConfirmManufacturingProcessStep" />

  <ConfirmDeleteModal :input="itemDeleteManufacturingStep" @close="onCloseDeleteManufacturingProcessStep" @confirm="onConfirmDeleteManufacturingProcessStep" :refresh="refresh" />

  <div class="hidden">
    <hr />
    {{ record }}
    <hr />
    {{ template }}
  </div>

  <div id="alert-form-error" class="opacity-0 hidden z-50 fixed top-2 z-50 px-3 w-full flex justify-center">
    <div class="border border-red-700 max-w-5xl flex items-center p-4 mb-4 text-red-800 rounded-lg bg-red-50  " role="alert">
      <svg class="flex-shrink-0 w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
        <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
      </svg>
      <span class="sr-only">Info</span>
      <div class="ms-3 text-sm font-medium px-6" v-html="message_alert" />
      <button
        type="button"
        class="ms-auto -mx-1.5 -my-1.5 bg-red-50 text-red-500 rounded-lg focus:ring-2 focus:ring-red-400 p-1.5 hover:bg-red-200 inline-flex items-center justify-center h-8 w-8   "
        data-dismiss-target="#alert-form-error"
        aria-label="Close"
      >
        <span class="sr-only">Close</span>
        <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
        </svg>
      </button>
    </div>
  </div>
  <div id="alert-form-success" class="opacity-0 hidden z-50 fixed top-2 z-50 px-3 w-full flex justify-center">
    <div class="border border-green-700 max-w-5xl flex items-center p-4 mb-4 text-green-800 rounded-lg bg-green-50  " role="alert">
      <svg class="flex-shrink-0 w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
        <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
      </svg>
      <span class="sr-only">Info</span>
      <div class="ms-3 text-sm font-medium px-6">Opération réussie</div>
      <button
        type="button"
        class="ms-auto -mx-1.5 -my-1.5 bg-green-50 text-green-500 rounded-lg focus:ring-2 focus:ring-red-400 p-1.5 hover:bg-green-200 inline-flex items-center justify-center h-8 w-8   "
        data-dismiss-target="#alert-form-success"
        aria-label="Close"
      >
        <span class="sr-only">Close</span>
        <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
/*
 Une erreur est intervenue lors de la sauvegarde <a href="#"
                        class="font-semibold underline hover:no-underline">Pour plus d'information</a>. Ré-essayez plus
                    tard.

    */
import { v4 as uuidv4 } from "uuid";
import B4FForm from "@/components/FormComponent.vue";
import service from "@/services/FullService.vue";
import SelectImageModal from "@/components/modals/SelectImageModal.vue";
import GenerateSheetModal from "@/components/modals/GenerateSheetModal.vue";

import Handlebars from "handlebars";
import PostalAddressModal from "@/components/modals/PostalAddressModal.vue";

import HuntingBatchModal from "@/components/modals/HuntingBatchModal.vue";

import ContactManagementModal from "@/components/modals/ContactManagementModal.vue";
import SupplierModal from "@/components/modals/SupplierModal.vue";
import AttributModal from "@/components/modals/AttributModal.vue";
import WildGameMoveModal from "@/components/modals/WildGameMoveModal.vue";
import WildGameEditModal from "@/components/modals/WildGameEditModal.vue";
import DeleteDiagramModal from "@/components/modals/DeleteDiagramModal.vue";
import HunterChangeModal from "@/components/modals/HunterChangeModal.vue";
import BatchNumberChangeModal from "@/components/modals/BatchNumberChangeModal.vue";

import BatchNumberChangeModal2 from "@/components/modals/BatchNumberChangeModal2.vue";
import DeliveryNumberChangeModal from "@/components/modals/DeliveryNumberChangeModal.vue";

import VetoControlMoveModal from "@/components/modals/VetoControlMoveModal.vue";
import ItemDeleteModal from "@/components/modals/ItemDeleteModal.vue";
import SendMailModal from "@/components/modals/SendMailModal.vue";
import PurchaseItemModal from "@/components/modals/PurchaseItemModal.vue";
import DeliveryReportModal from "@/components/modals/DeliveryReportModal.vue";
import PickupReportModal from "@/components/modals/PickupReportModal.vue";
import CreateSectionModal from "@/components/modals/CreateSectionModal.vue";
import SelectRecipeStepModal from "@/components/modals/SelectRecipeStepModal.vue";
import SendMailsGeneratePdfModal from "@/components/modals/SendMailsGeneratePdfModal.vue";
import ConfirmDeleteModal from "@/components/modals/ConfirmDeleteModal.vue";
import ModalField from "@/components/modals/ManageFieldEditModal.vue";
import { unflatten, flatten } from "flat";
import { Modal, Dismiss } from "flowbite";

import { mapGetters } from "vuex";

export default {
  name: "FormView",

  emits: ["openMenu"], // déclare l’événement
  inheritAttrs: false, // évite l’attachement auto au root
  components: {
    B4FForm,
    SendMailsGeneratePdfModal,
    PurchaseItemModal,
    PickupReportModal,
    DeliveryReportModal,
    DeleteDiagramModal,
    SelectImageModal,
    GenerateSheetModal,
    ModalField,
    SupplierModal,
    PostalAddressModal,
    HuntingBatchModal,
    AttributModal,
    WildGameEditModal,
    WildGameMoveModal,
    ContactManagementModal,
    HunterChangeModal,
    BatchNumberChangeModal,
    BatchNumberChangeModal2,
    DeliveryNumberChangeModal,
    VetoControlMoveModal,
    ItemDeleteModal,
    SendMailModal,
    CreateSectionModal,
    SelectRecipeStepModal,
    ConfirmDeleteModal,
  },
  props: {
    //   refresh: { type: [String, Number, Date], default: null }
  },
  data() {
    return {
      config: {},
      record: {},
      countries: [],
      customAction: {
        type: "",
        timestamp: "",
        attribut: "",
        value: "",
      },

      datasource_id: null,

      refresh_veto: null,
      back: "",
      message_alert: "",
      dismiss: null,
      success: null,
      category: null,
      empty: null,
      currentImageField: null,
      toasts: [],
      inputAddress: {},
      inputContact: {},
      inputAttribut: {},
      inputSupplier: {},
      inputWildGameEdit: {},
      inputWildGameMove: {},
      inputHuntingBatch: {},
      inputDeliveryReport: {},
      inputPickupReport: {},
      inputPurchaseItemAdd: {},
      inputPurchaseItemModify: {},
      inputSendEmailsGeneratePdf: {},
      inputItemDelete: {},
      sendMailDelete: {},

      itemManufacturingStep: {},
      itemDeleteManufacturingStep: {},
      itemSection: {
        id: "",
        name: "Quantité",
      },

      inputHunterChange: {},
      inputBatchReportUpdate: {},

      inputBatchNumberUpdate: {},
      inputDeliveryNumberUpdate: {},

      inputVetoControlMove: {},
      recordDelete: {},
      currentImageIndex: null,
      template: {},
      surveyModal: null,
      generateSheetModal: null,
      modalField: null,
      modalAttribut: null,
      modalWildGameEdit: null,
      modalWildGameMove: null,
      createSectionModal: null,
      modalHunterChange: null,
      modalBatchReportUpdate: null,
      modalBatchNumberUpdate: null,
      modalDeliveryNumberUpdate: null,

      modalVetoControlMove: null,
      modalSendMail: null,
      modalItemDelete: null,

      modalHuntingBatch: null,
      modalDeliveryReport: null,
      manufacturingStepModal: null,
      modalPickupReport: null,
      sendMailsGeneratePdf: null,
      modalPurchaseItem: null,
      confirmDeleteModal: null,
      modalDelete: null,

      modalSupplier: null,
      modalPostalAddress: null,
      modalContentManagement: null,
      lg: "FR",
      title: "",
      button: "",

      current_tab: 0,
    };
  },

  computed: {
    ...mapGetters({ user: "StateUser" }),
    isLoggedIn: function () {
      return this.$store.getters.isAuthenticated;
    },
  },
  watch: {
    "$route.params.rid": function () {
      
      //        this.loadPageRecord()
      this.current_tab = parseInt(this.$route.query.tab);
    },
    "$route.query.tab": function () {
     
      //        this.loadPageRecord()
      this.current_tab = parseInt(this.$route.query.tab);
    },
    "$route.params.id": function () {
      
    },
    "$route.query.page": function () {
      this.back = this.$route.query.page;
 
      this.current_tab = parseInt(this.$route.query.tab);
      this.loadPageRecord();
    },
    category: function () {
    
      this.loadPageConfig();
    },
    config: function (val) {
      
      if (val) {
        if (val.title) this.title = val.title[this.lg];
        if (val.button) this.button = val.button[this.lg];
      }
    },
    template: function () {
     
    },
  },
  async mounted() {
     
    if (this.user == undefined) {
      //this.$router.push("/login");
      window.location = "/login";
      return;
    }

    this.current_tab = parseInt(this.$route.query.tab);

    //  if (this.$route.params.id == "batches") {
    //      //this.$router.push("/login");
    //      window.location = "/admin/batches/" + this.$route.params.rid
    //      return;
    //  }

    if (this.$route.query.back != undefined) {
      this.back = this.$route.query.back;
    }

    const modalEl = document.getElementById("select-image-modal");
    this.surveyModal = new Modal(modalEl, {
      placement: "center",
      backdrop: "static",
      closable: false,
    });

    const modalEl2 = document.getElementById("generate-sheet-modal");
    this.generateSheetModal = new Modal(modalEl2, {
      placement: "center",
      backdrop: "static",
      closable: false,
    });

    const modalEl3 = document.getElementById("manage-field-edit-modal");
    this.modalField = new Modal(modalEl3, {
      placement: "center",
      backdrop: "static",
      closable: false,
    });
    const modalEl4 = document.getElementById("create-postal-address-modal");
    this.modalPostalAddress = new Modal(modalEl4, {
      placement: "center",
      backdrop: "static",
      closable: false,
    });

    const modalEl5 = document.getElementById("create-contact-modal");
    this.modalContentManagement = new Modal(modalEl5, {
      placement: "center",
      backdrop: "static",
      closable: false,
    });

    const modalEl6 = document.getElementById("create-supplier-modal");
    this.modalSupplier = new Modal(modalEl6, {
      placement: "center",
      backdrop: "static",
      closable: false,
    });

    const modalEl7 = document.getElementById("create-attribut-modal");
    this.modalAttribut = new Modal(modalEl7, {
      placement: "center",
      backdrop: "static",
      closable: false,
    });

    const modalEl8 = document.getElementById("show-wild-game-modal");
    this.modalWildGame = new Modal(modalEl8, {
      placement: "center",
      backdrop: "static",
      closable: false,
    });

    const modalEl9 = document.getElementById("create-hunting-batch-modal");
    this.modalHuntingBatch = new Modal(modalEl9, {
      placement: "center",
      backdrop: "static",
      closable: false,
    });

    const modalEl10 = document.getElementById("delete-diagram-modal");
    this.modalDelete = new Modal(modalEl10, {
      placement: "center",
      backdrop: "static",
      closable: false,
    });

    const modalEl11 = document.getElementById("move-wild-game-modal");
    this.modalWildGameMove = new Modal(modalEl11, {
      placement: "center",
      backdrop: "static",
      closable: false,
    });

    const modalEl12 = document.getElementById("change-hunter-modal");
    this.modalHunterChange = new Modal(modalEl12, {
      placement: "center",
      backdrop: "static",
      closable: false,
    });

    const modalEl13 = document.getElementById("create-batch-report-modal");
    this.modalBatchReportUpdate = new Modal(modalEl13, {
      placement: "center",
      backdrop: "static",
      closable: false,
    });

    const modalEl13b = document.getElementById("create-batch-number-modal");
    this.modalBatchNumberUpdate = new Modal(modalEl13b, {
      placement: "center",
      backdrop: "static",
      closable: false,
    });

    const modalEl13d = document.getElementById("change-delivery-number-modal");
    this.modalDeliveryNumberUpdate = new Modal(modalEl13d, {
      placement: "center",
      backdrop: "static",
      closable: false,
    });

    const modalEl14 = document.getElementById("move-veto-control-modal");
    this.modalVetoControlMove = new Modal(modalEl14, {
      placement: "center",
      backdrop: "static",
      closable: false,
    });

    const modalEl15 = document.getElementById("delete-item-modal");
    this.modalItemDelete = new Modal(modalEl15, {
      placement: "center",
      backdrop: "static",
      closable: false,
    });

    const modalEl16 = document.getElementById("send-mail-modal");
    this.modalSendMail = new Modal(modalEl16, {
      placement: "center",
      backdrop: "static",
      closable: false,
    });

    const modalEl17 = document.getElementById("create-purchase-item-modal");
    this.modalPurchaseItem = new Modal(modalEl17, {
      placement: "center",
      backdrop: "static",
      closable: false,
    });

    const modalEl18 = document.getElementById("create-delivery-report-modal");
    this.modalDeliveryReport = new Modal(modalEl18, {
      placement: "center",
      backdrop: "static",
      closable: false,
    });

    const modalEl19 = document.getElementById("create-pickup-report-modal");
    this.modalPickupReport = new Modal(modalEl19, {
      placement: "center",
      backdrop: "static",
      closable: false,
    });

    const modalEl30 = document.getElementById("send-mails-generate-pdf");
    this.modalSendMailsGeneratePdf = new Modal(modalEl30, {
      placement: "center",
    });

    const modalEl40 = document.getElementById("create-section-modal");
    this.createSectionModal = new Modal(modalEl40, {
      placement: "center",
      backdrop: "static",
      closable: false,
    });

    const modalEl41 = document.getElementById("select-recipe-step-modal");
    this.manufacturingStepModal = new Modal(modalEl41, {
      placement: "center",
      backdrop: "static",
      closable: false,
    });

    const modalEl42 = document.getElementById("select-recipe-step-confirm-delete-modal");
    this.confirmDeleteModal = new Modal(modalEl42, {
      placement: "center",
      backdrop: "static",
      closable: false,
    });

    await this.loadCountries();

    // options object

 

    this.category = null;
    //
    //

    if (this.$route.params.id != undefined) {
      this.datasource_id = await service.getDatasourceId(this.$route.params.id, this.user?.token);
    }

    await this.loadPageRecord();

    if (this.$route.params.id == "product-suppliers") {
      this.template = {
        source_id: "661857eb2cdd7ea01681abe8",
      };
    }

  
  },
  methods: {
    onOpenDeleteManufacturingProcessStep: function (event) {
      this.itemDeleteManufacturingStep = {
        mode: "delete-step",

        attribute: event?.attribute,
        sub_attribute: event?.sub_attribute,
        parent_id: event?.parent_id,
        item_id: event?.item_id,
        name: event.name,
      };

      this.refresh = Math.random().toString(36).substring(7);

      this.confirmDeleteModal.show();
    },
    onConfirmDeleteManufacturingProcessStep: function (event) {
    
      function removeItemOnce(arr, index) {
        if (index > -1) {
          arr.splice(index, 1);
        }
        return arr;
      }

      if (event.mode == "delete-section") {
        let sectionIndex = this.record[event.attribute].findIndex(function (a) {
          return a.id == event.item_id;
        });

        if (sectionIndex != -1) {
          let sections = this.record[event.attribute];

          this.record[event.attribute] = removeItemOnce(sections, sectionIndex);
        } else alert("sectionIndex == -1  --- " + event.item_id);
      }

      if (event.mode == "delete-step") {
        let section = this.record[event.attribute].find(function (a) {
          return a.id == event.parent_id;
        });
        if (section == undefined) {
          return;
        } else {
          for (let i = 0; i < section.lines.length; i++) {
            if (section.lines[i].id == event.item_id) {
              //   this.lines = this.output;
              section.lines = removeItemOnce(section.lines, i);
            }
          }
        }
      }

      this.confirmDeleteModal.hide();
    },

    onOpenDeleteManufacturingProcessSection: function (event) {
      this.itemDeleteManufacturingStep = {
        mode: "delete-section",

        attribute: event?.attribute,
        sub_attribute: event?.sub_attribute,
        parent_id: null,
        item_id: event?.item_id,
        name: event.name,
      };

      this.refresh = Math.random().toString(36).substring(7);

      this.confirmDeleteModal.show();
    },

    onCloseDeleteManufacturingProcessStep: function () {
      this.confirmDeleteModal.hide();
    },

    onCreateManufacturingProcessStep: function (event) {
      this.itemManufacturingStep = {
        mode: "create",
        parent_id: event.parent_id,
        index: null,
        attribute: event.attribute,
        sub_attribute: event.sub_attribute,

        name: "",
        description: "",
        duration: "00:00",
        workload: "00:00",
        controls: [],
      };

      this.refresh = Math.random().toString(36).substring(7);

      this.manufacturingStepModal.show();
    },
    onEditManufacturingProcessStep: function (event) {
      this.itemManufacturingStep = {
        mode: "edit",
        parent_id: event.parent_id,
        item_id: event.item_id,
        index: null,
        attribute: event.attribute,
        sub_attribute: event.sub_attribute,

        name: event.name,
        description: event.description,
        duration: event.duration,
        workload: event.workload,
        controls: event.controls,
      };

      this.refresh = Math.random().toString(36).substring(7);

      this.manufacturingStepModal.show();
    },

    onCloseManufacturingProcessStep: function () {
      this.manufacturingStepModal.hide();
    },
    onConfirmManufacturingProcessStep: function (event) {
      if (this.record[event.attribute] == undefined) return;

      if (event.mode == "create") {
        let item = {
          id: Math.random().toString(36).substring(7),
          name: event.name,
          description: event.description,
          duration: event.duration,
          workload: event.workload,
          controls: event.controls,
        };

        let section = this.record[event.attribute].find(function (a) {
          return a.id == event.parent_id;
        });
        if (section == undefined) {
          alert("section == undefined");
          return;
        } else {
          if (section.lines == undefined) section.lines = [];
          section.lines.push(item);
        }
      }
      if (event.mode == "edit") {
        {
          let section = this.record[event.attribute].find(function (a) {
            return a.id == event.parent_id;
          });
          if (section == undefined) {
            return;
          } else {
            if (section.lines == undefined) section.lines = [];

            let item = {
              id: event.item_id,
              name: event.name,
              description: event.description,
              duration: event.duration,
              workload: event.workload,
              controls: event.controls,
            };

            let lineIndex = section.lines.findIndex(function (a) {
              return a.id == event.item_id;
            });

            section.lines[lineIndex] = item;
          }
        }
      }
     
      this.manufacturingStepModal.hide();
    },

    onOpenEditSection: function (event) {
      this.itemSection = {
        mode: "edit",
        name: event.name,
        item_id: event.item_id,
        index: null,
        attribute: event.attribute,
        title: "Ajouter un produit",
        description: "Veuillez Saisir le nom de l'article",
      };

      this.refresh = Math.random().toString(36).substring(7);

      this.createSectionModal.show();
    },

    onOpenCreateSection: function (event) {
      this.itemSection = {
        mode: "create",
        name: "",
        index: null,
        attribute: event.attribute,
        title: "Ajouter un produit",
        description: "Veuillez Saisir le nom de l'article",
      };

      this.refresh = Math.random().toString(36).substring(7);

      this.createSectionModal.show();
    },
    onOpenCloseSection: function () {
      this.createSectionModal.hide();
    },
    onOpenConfirmSection: function (event) {
      if (event == undefined) return;
      if (event.mode == "create") {
        let section = {
          id: Math.random().toString(36).substring(7),
          name: event.name,
          lines: [],
        };

        if (this.record[event.attribute] == undefined) this.record[event.attribute] = [];

        this.record[event.attribute].push(section);
      }
      if (event.mode == "edit") {
        let sectionIndex = this.record[event.attribute].findIndex(function (a) {
          return a.id == event.item_id;
        });

        if (sectionIndex != -1) {
          this.record[event.attribute][sectionIndex].name = event.name;
        }
      }

      this.createSectionModal.hide();
    },

    addToast(message, type = "success") {
      const id = Date.now(); // ID unique pour chaque toast
      this.toasts.push({ id, message, type });

      // Supprime le toast après 4s
      setTimeout(() => {
        this.removeToast(id);
      }, 2000);
    },

    removeToast(id) {
      this.toasts = this.toasts.filter((toast) => toast.id !== id);
    },

    OnSendMailConfirm() {
      alert("to do");
    },

    OnSendMailCancel() {
      alert("to do");
    },

    async OnClickSendMailsGeneratePdfConfirm(event) {
      /**111**/
 

      let properties = {
        record_id: this.record._id,
        document: event.document,
        generate_pdf: event.generate_pdf,
        send_to: event.emails,
      };

      let response = await service.runFunctionV2("nemrod-generate-pdf-game-delivery-note", properties, this.user?.token);

      if (response?.status == "OK") {
        if (response?.message != null) this.addToast(response?.message, "success");
        //   await this.loadPageRecord();
      } else {
        //   this.addToast(response?.message, "error");
      }

      this.modalSendMailsGeneratePdf.hide();
    },

    async OnClickPickupReportConfirm(event) {
      /**111**/

      let properties = {
        action: event.action,

        record_id: this.record._id.toString(),
        hunter_id: event.target.hunter_id,

        member_id: event.target.member_id,
        done_at: event.target.done_at,
        type: event.target.type,
      };

      let response = await service.runFunctionV2("nemrod-update-pickup-report-3", properties, this.user?.token);

      //                let response = await service.runFunction("nemrod-update-delivery-report-core-update", properties, this.user?.token)

      if (response?.status == "OK") {
        if (response?.message != null) this.addToast(response?.message, "success");
        await this.loadPageRecord();
      } else {
        this.addToast(response?.message, "error");
      }

      this.modalPickupReport.hide();
    },

    OnClickPickupReportCancel() {
      /**111**/

      this.modalPickupReport.hide();
    },

    OnClickSendMailsGeneratePdfCancel() {
      this.modalSendMailsGeneratePdf.hide();
    },

    OnClickDeliveryReportCancel() {
      /**111**/

      this.modalDeliveryReport.hide();
    },

    async OnClickDeliveryReportConfirm(event) {
      /**111**/

      
      let properties = {
        action: event.action,

        record_id: this.record._id.toString(),
        hunter_id: event.target.hunter_id,
        pricing_catalog_id: event.target.pricing_catalog_id,
        member_id: event.target.member_id,
        done_at: event.target.done_at,
        type: event.target.type,
        temperature: event.target.temperature,
        temperature_unit: event.target.temperature_unit,
      };

      let response = await service.runFunctionV2("nemrod-update-delivery-report-2", properties, this.user?.token);

      //                let response = await service.runFunction("nemrod-update-delivery-report-core-update", properties, this.user?.token)

      if (response?.status == "OK") {
        if (response?.message != null) this.addToast(response?.message, "success");
        await this.loadPageRecord();
      } else {
        this.addToast(response?.message, "error");
      }

      this.modalDeliveryReport.hide();
    },

    OnClickPurchaseItemCancel() {
      this.modalPurchaseItem.hide();
    },

    OnClickPurchaseItemConfirm() {
      this.modalPurchaseItem.hide();
    },

    OnClickDeleteCancel() {
      this.modalDelete.hide();
      this.modalDelete = null;
    },
    OnClickDeleteConfirm() {
      this.modalDelete.hide();
      this.modalDelete = null;
    },

    displayConfirmation() {
 

      // target element that will be dismissed
      const $targetEl = document.getElementById("alert-form-success");

      // optional trigger element
      const $triggerEl = null;

      $targetEl.classList.add("opacity-100");
      $targetEl.classList.remove("opacity-0");
      $targetEl.classList.remove("hidden");
      const options = {
        transition: "transition-opacity",
        duration: 5000,
        timing: "ease-out",

        // callback functions
        onHide: (/*context, targetEl*/) => {
      
          
        },
      };

      // instance options object
      const instanceOptions = {
        id: "alert-form-success",
        override: true,
      };
      if (this.sucess == undefined) this.sucess = new Dismiss($targetEl, $triggerEl, options, instanceOptions);
      this.sucess.hide();
    },
    displayAlert() {
      // target element that will be dismissed
      const $targetEl = document.getElementById("alert-form-error");

      // optional trigger element
      const $triggerEl = null;

      $targetEl.classList.add("opacity-100");
      $targetEl.classList.remove("opacity-0");
      $targetEl.classList.remove("hidden");
      const options = {
        transition: "transition-opacity",
        duration: 2500,
        timing: "ease-out",

        // callback functions
        onHide: (/*context, targetEl*/) => {
         
 
        },
      };

      // instance options object
      const instanceOptions = {
        id: "alert-form-error",
        override: true,
      };
      if (this.dismiss == undefined) this.dismiss = new Dismiss($targetEl, $triggerEl, options, instanceOptions);
      this.dismiss.hide();
    },

    modalFieldClose: function () {
      this.modalField.hide();
    },

    OnPostalAddressClose: function () {
      this.modalPostalAddress.hide();
    },

    OnSupplierClose: function () {
      this.modalSupplier.hide();
    },

    OnAttributClose: function () {
      this.modalAttribut.hide();
    },

    OnHuntingBatchClose: function () {
      this.modalHuntingBatch.hide();
    },

    OnHuntingBatchConfirm: async function (event) {
      //PV1024b
      let properties = {
        record_id: event.id,
        action: event.action,
        properties: {
          id: event.target.id,
          number: event.target.number,

          state: event.target.state,

          category_id: event.target.species_id,
          weight_gross: event.target.weight_gross,
          weight_discount_nemrod: event.target.weight_discount_nemrod,
          weight_discount_vet: event.target.weight_discount_vet,

          reception_state: event.target.reception_state,
          reception_comment_id: event.target.reception_comment_id,
          reception_comment: event.target.reception_comment,

          skinning_state: event.target.skinning_state,
          skinning_comment_id: event.target.skinning_comment_id,
          skinning_comment: event.target.skinning_comment,

          vet_state: event.target.vet_state,

          vet_comment_id: event.target.vet_comment_id,
          vet_comment: event.target.vet_comment,

          nemrod_state: event.target.nemrod_state,
          nemrod_comment_id: event.target.nemrod_comment_id,
          nemrod_comment: event.target.nemrod_comment,

          batches: event.target.batches,
        },
      };

      let response = await service.runFunctionV2("nemrod-update-game-3", properties, this.user?.token);

      if (response?.status == "OK") {
        //this.record.items = response?.record.items
        //this.record.amount = response?.record?.amount
        //this.record.weight_net = response?.record?.weight_net
        //this.record.weight_gross = response?.record?.weight_gross
        //this.record.weight_discount = response?.record?.weight_discount
        //      this.record.company_id = event.target.id
        //      this.record.company._id = event.target.id
        //      this.record.company.name = event.target.name
        //      this.record.company.reference = event.target.reference
        //      this.record.company.image_id = event.target.image_id
        //      this.record.amount = response?.record?.amount
        //      this.record.amount = response?.record?.amount
        //      this.record.items = response?.record?.items
        if (response?.message != null) this.addToast(response?.message, "success");
        await this.loadPageRecord();
      } else {
        this.addToast(response?.message, "error");
      }

      this.modalHuntingBatch.hide();
    },

    OnWildGameEditCancel: function () {
      this.modalWildGameEdit.hide();
    },

    OnWildGameMoveCancel: function () {
      this.modalWildGameMove.hide();
    },

    OnHunterChangeCancel: function () {
      this.modalHunterChange.hide();
    },
    OnHunterChangeConfirm: async function (event) {
      let properties = {
        record_id: event.id,
        company: {
          _id: event.target.id,
          name: event.target.name,
        },
      };

      let response = await service.runFunction("nemrod-change-hunter-in-ba", properties, this.user?.token);

      if (response?.status == "OK") {
        this.record.company_id = event.target.id;
        this.record.company._id = event.target.id;
        this.record.company.name = event.target.name;
        this.record.company.reference = event.target.reference;
        this.record.company.image_id = event.target.image_id;

        this.record.amount = response?.record?.amount;
        this.record.items = response?.record?.items;
      }
      this.modalHunterChange.hide();
    },
    OnItemDeleteCancel: function () {
      this.modalItemDelete.hide();
    },
    OnItemDeleteConfirm: async function (event) {
      let properties = {
        name: event.name,
        action: event.source.action,
        record_id: event.source.id,
        id: event.source.item_id,
        //  event: event,
        properties: {
          record_id: event.source.id,
          id: event.source.item_id,
        },
      };

      //  alert(event.action);

      let fn = "nemrod-delete-item-2";

      if (event.action == "delete-hunting-batch-2") event.action = "nemrod-delete-item-from-batch-2";

      if (event.action == "delete-item-from-batch-2") {
        event.action = "nemrod-delete-item-from-batch-2";
        fn = "nemrod-delete-item-from-batch-2";
      }
      if (event.action == "delete-item-from-pickup-2") {
        event.action = "nemrod-delete-item-from-pickup-2";
        fn = "nemrod-delete-item-from-pickup-2";
      }

      if (event.action == "delete-game-item-2") {
        fn = "nemrod-delete-game-3";
        event.action = "nemrod-delete-game-3";
      }

      if (event.action == "delete-game-item-3") {
        fn = "nemrod-delete-game-3";
        event.action = "nemrod-delete-game-3";
      }

      if (event.action == "delete-game-2") {
        fn = "nemrod-delete-game-3";
        event.action = "nemrod-delete-game-2";
      }

      if (event.action == "delete-game-delivery-report-2") {
        fn = "nemrod-delete-game-delivery-note-3";
        event.action = "nemrod-delete-game-delivery-note-3";
      }

      if (event.action == "delete-game-pickup-note-2") {
        fn = "nemrod-delete-game-pickup-note-3";
        event.action = "nemrod-delete-game-pickup-note-3";
      }

      if (event.action == "delete-game-batch-2") {
        fn = "nemrod-delete-game-batch-report-3";
        event.action = "nemrod-delete-game-batch-report-3";
      }

      //delete-game-delivery-report-2
      // delete -game - delivery - report - 2
      let response = await service.runFunctionV2(fn, properties, this.user?.token);
  
      this.modalItemDelete.hide();
      if (response?.status == "OK") {
        if (response?.message != null) this.addToast(response?.message, "success");
        await this.loadPageRecord();
        if (event.action == "nemrod-delete-game-delivery-note-3") {
          // alert(this.$route.currentRoute);

          if (this.$route.query.back != undefined) {
            this.$router.push(this.$route.query.back);
            return;
          }
          this.$router.push("/admin/views/private-inbound-hunting-items-2");
          return;
        }
      } else {
        this.addToast(response?.message, "error");
      }
      await this.loadPageRecord();
    },
    OnBatchReportUpdateCancel: function () {
      this.modalBatchNumberUpdate.hide();
    },

    OnBatchNumberUpdateCancel: function () {
      this.modalBatchReportUpdate.hide();
    },

    OnBatchReportUpdateConfirm: async function (event) {
    

      let properties = {
        id: event.id,
        action: event.action,
        entity_id: event.entity_id,
        properties: {
          controlled_at: event.target.controlled_at,
          entity_id: event.entity_id,

          controlled_by_id: event.target.controlled_by_id,
          reviewed_by_id: event.target.reviewed_by_id,
        },
      };

      let response = await service.runFunctionV2("nemrod-update-batch-number-1", properties, this.user?.token);
      this.modalBatchNumberUpdate.hide();

      if (response?.status == "OK") {
        if (response?.message != null) this.addToast(response?.message, "success");
        await this.loadPageRecord();
      } else {
        this.addToast(response?.message, "error");
      }
    },

    OnBatchNumberNumberCancel: function () {
      this.modalBatchNumberUpdate.hide();
    },
    OnBatchNumberNumberConfirm: async function (event) {
      

      let properties = {
        id: event.id,
        action: event.action,
        entity_id: event.entity_id,
        properties: {
          batch_number: event.target.batch_number,
        },
      };

      let response = await service.runFunctionV2("nemrod-change-batch-number-1", properties, this.user?.token);
      this.modalBatchNumberUpdate.hide();

      if (response?.status == "OK") {
        if (response?.message != null) this.addToast(response?.message, "success");
        await this.loadPageRecord();
      } else {
        this.addToast(response?.message, "error");
      }
    },

    OnDeliveryNumberNumberCancel: function () {
      this.modalDeliveryNumberUpdate.hide();
    },

    OnDeliveryNumberNumberConfirm: async function (event) {
 

      let properties = {
        id: event.id,
        action: event.action,
        entity_id: event.entity_id,
        properties: {
          delivery_number: event.target.delivery_number,
        },
      };

      let response = await service.runFunctionV2("nemrod-change-delivery-number-1", properties, this.user?.token);
      this.modalDeliveryNumberUpdate.hide();

      if (response?.status == "OK") {
        if (response?.message != null) this.addToast(response?.message, "success");
        await this.loadPageRecord();
      } else {
        this.addToast(response?.message, "error");
      }
    },

    OnVetoControlMoveCancel: function () {
      this.modalVetoControlMove.hide();
    },
    OnVetoControlMoveConfirm: async function (event) {
      let properties = {
        id: event.id,
        source: event.source,
        target: event.target,
      };

      if (event.action == "move-control-veto-2") {
        let response = await service.runFunction("nemrod-move-game-batch-3", properties, this.user?.token);
        if (response?.status == "OK") {
          if (response?.message != null) this.addToast(response?.message, "success");
          this.record.items = response?.record?.items;
        }
      }

      if (event.action == "add-control-veto") {
        let response = await service.runFunction("nemrod-add-game-batch", properties, this.user?.token);
        if (response?.status == "OK") {
          if (response?.message != null) this.addToast(response?.message, "success");
          this.record.items = response?.record?.items;
        }
      }

      if (event.action == "move-game-batch-2") {
        let response = await service.runFunctionV2("nemrod-move-game-batch-3", properties, this.user?.token);
        if (response?.status == "OK") {
          if (response?.message != null) this.addToast(response?.message, "success");
          await this.loadPageRecord();
        } else {
          this.addToast(response?.message, "error");
        }
      }

      if (event.action == "move-game-delivery-2") {
        let response = await service.runFunctionV2("nemrod-move-game-delivery-3", properties, this.user?.token);
        if (response?.status == "OK") {
          if (response?.message != null) this.addToast(response?.message, "success");
          await this.loadPageRecord();
        } else {
          this.addToast(response?.message, "error");
        }
      }

      if (event.action == "move-game-pickup-3") {
        let response = await service.runFunctionV2("nemrod-move-game-pickup-3", properties, this.user?.token);
        if (response?.status == "OK") {
          if (response?.message != null) this.addToast(response?.message, "success");
          await this.loadPageRecord();
        } else {
          this.addToast(response?.message, "error");
        }
      }

      if (event.action == "add-game-batch-2") {
        let response = await service.runFunctionV2("nemrod-add-game-batch-2", properties, this.user?.token);
        if (response?.status == "OK") {
          if (response?.message != null) this.addToast(response?.message, "success");
          await this.loadPageRecord();
        } else {
          this.addToast(response?.message, "error");
        }
      }

      this.modalVetoControlMove.hide();
    },
    OnContactManagementClose: function () {
      this.modalContentManagement.hide();
    },
    OnWildGameMoveConfirm: async function (event) {
      let properties = {
        id: event.id,
        action: event.action,
        source: event.source,
        target: event.target,
      };

      let action = "nemrod-move-game-delivery-3";

      if (event.action == "move-game-pickup-3") action = "nemrod-move-game-pickup-3";

      let response = await service.runFunctionV2(action, properties, this.user?.token);
      if (response?.status == "OK") {
        if (response?.message != null) this.addToast(response?.message, "success");
        await this.loadPageRecord();
      } else {
        this.addToast(response?.message, "error");
      }
      this.modalWildGameMove.hide();
    },
    OnWildGameEditConfirm: function () {
      alert("todo");
    },
    manageButtonClick: async function (event) {
      if (event.action == "redirect") {
        window.open(event.properties.url, "_blank");
      }
      if (event.action == "add-user") {
        let inputContact = {
          id: null,
          civility: null,
          firstname: null,
          lastname: null,
          email: null,
          phone: null,
          mobile: null,
          role: null,
        };

        this.inputContact = inputContact;

        this.modalContentManagement.show();
        return;
      }
      if (event.action == "add-attribut") {
        let inputAttribut = {
          id: null,
          mode: "new",
          name: { FR: null, EN: null },
          description: { FR: null, EN: null },
          default: null,
          linked: null,
          type: "string",
        };

        this.inputAttribut = inputAttribut;

        this.modalAttribut.show();
        return;
      }
      if (event.action == "add-address") {
        let inputAddress = {
          id: null,
          building: null,
          street: null,
          code: null,
          city: null,
          country: null,
          for: null,
          phone: null,
          siret: null,
          gs1_gln: null,
          is_main_site: null,
        };

        this.inputAddress = inputAddress;

        this.modalPostalAddress.show();
        return;
      }
      if (event.action == "add-supplier") {
        let inputSupplier = {
          id: null,
          name: this.record?.name,
          currency: "€",
          reference: null,
          price: null,
          quantity: null,
          entity_id: [],
          supplier_id: null,
          supplier_name: null,
          supplier: {},
        };

        this.inputSupplier = inputSupplier;

        this.modalSupplier.show();

        return;
      }
      if (event.action == "edit") {
        let inputAddress = {
          id: event.data._id,
          building: event.data.building,
          street: event.data.street,
          code: event.data.code,
          city: event.data.city,
          country: event.data.country,
          for: event.data.for,
          phone: event.data.phone,
          siret: event.data?.siret,

          gs1_gln: event.data?.gs1_gln,
          is_main_site: event.data?.is_main_site,
        };
        this.inputAddress = inputAddress;
        this.modalPostalAddress.show();
        return;
      }

      if (event.action == "edit-user") {
        let inputContact = {
          id: event.data?.id ? event.data?.id : event.data?._id,
          civility: event.data?.civility,
          firstname: event.data?.firstname,
          lastname: event.data?.lastname,
          email: event.data?.email,
          phone: event.data?.phone,
          mobile: event.data?.mobile,
          role: event.data?.role,
        };

        this.inputContact = inputContact;

        this.modalContentManagement.show();
        return;
      }

      if (event.action == "edit-supplier") {
        let inputSupplier = {
          id: event.data._id,
          name: event.data.name,
          entity_id: event.data.entity_id,
          quantity: event.data.quantity,
          price: event.data.price,
          currency: event.data.currency,
          url: event.data.url,
          reference: event.data.reference,

          supplier_id: event.data.supplier_id,
          supplier_name: event.data.supplier_name,
          supplier_image_id: event.data.supplier_image_id,

          supplier: event.data.supplier,
        };

        this.inputSupplier = inputSupplier;
        this.modalSupplier.show();
        return;
      }
      if (event.action == "edit-attribute") {
        let inputAttribut = {
          id: event.data.id,
          mode: "edit",
          name: event.data.name,
          description: event.data.description,
          default: event.data.default,
          linked: null,

          type: event.data.type,
        };

        this.inputAttribut = inputAttribut;

        this.modalAttribut.show();
        return;
      }
      if (event.action == "mauriac-add-item") {
        let inputPurchaseItemAdd = {
          id: null,
          product_id: null,
          mode: "add",
          action: event.action,
          source: {
            supplier_id: this.record.supplier_id,
            supplier: {
              name: this.record.supplier.name,
            },
            items: this.record.items,
          },
        };

        this.inputPurchaseItemAdd = inputPurchaseItemAdd;
        this.modalPurchaseItem.show();
        return;
      }
      if (event.action == "edit-hunting-pickup-2" || event.action == "edit-hunting-ba-2" || event.action == "edit-hunting-batch-2") {
        let collection = "data-sources/67a64c919b18e54570576b89/records/" + event.data._id;
        let record = await service.getData(collection, this.user?.token, { limit: 1 });

        if (record == undefined) {
          return;
        }

        if (event.data.reception_state == undefined) event.data.reception_state = "OK";

        let inputHuntingBatch = {
          id: this.record._id,
          _id: this.record._id,
          price_catalog_name: record?.price_catalog?.name,
          price_catalog_id: record?.price_catalog?._id,
          mode: "edit",
          action: "edit-hunting-batch-2",
          source: {
            item_id: record._id,

            name: record.name,
            reference: record.reference,
            number: record.number,
            state: record.state,

            species_id: record.species_id,
            batches: record.batches,
            vet_state: record.vet_state,
            vet_comment_id: record.vet_comment_id,
            vet_comment: record.vet_comment,

            nemrod_state: record.nemrod_state,
            nemrod_comment_id: record.nemrod_comment_id,
            nemrod_comment: record.nemrod_comment,

            reception_state: record.reception_state,
            reception_comment_id: record.reception_comment_id || "",
            reception_comment: record.reception_comment || "",

            skinning_state: record.skinning_state || "OK",
            skinning_comment_id: record.skinning_comment_id || "",
            skinning_comment: record.skinning_comment || "",

            pickup_number: record.pickup_number,
            delivery_number: record.delivery_number,
            batch_number: record.batch_number,

            weight_gross: { value: record.weight_gross_value, unit: "kg" },
            weight_discount_nemrod: { value: record.weight_discount_nemrod_value, unit: record.weight_discount_unit },
            weight_discount_vet: { value: record.weight_discount_vet_value, unit: record.weight_discount_vet_unit },
            weight_discount_reception: { value: record.weight_discount_reception_value, unit: record.weight_discount_reception_unit },
            weight_discount_skinning: { value: record.weight_discount_skinning_value, unit: record.weight_discount_skinning_unit },

            weight_discount: { value: record.weight_gross_value, unit: "kg" },
            amount: record.amount,

            unit_price: parseFloat(record.unit_price),
            linked: null,
            type: event.data?.type,
          },
        };

        this.inputHuntingBatch = inputHuntingBatch;
        this.modalHuntingBatch.show();
        return;
      }
      if (event.action == "edit-hunting-ba" || event.action == "edit-hunting-batch") {
        if (event.data.reception_state == undefined) event.data.reception_state = "OK";

        let inputHuntingBatch = {
          id: this.record._id,
          price_catalog_name: this?.record?.price_catalog?.name,
          price_catalog_id: this?.record?.price_catalog?._id,
          mode: "edit",
          action: event.action,
          source: {
            item_id: event.data._id,

            name: event.data.name,
            reference: event.data.reference,
            number: event.data.number,
            state: event.data.state,

            vet_state: event.data.vet_state,
            species_id: event.data.species_id,

            vet_comment_id: event.data.vet_comment_id,
            vet_comment: event.data.vet_comment,

            nemrod_state: event.data.nemrod_state,
            nemrod_comment_id: event.data.nemrod_comment_id,
            nemrod_comment: event.data.nemrod_comment,

            reception_state: event.data.reception_state,
            reception_comment_id: event.data?.reception_comment_id || "",
            reception_comment: event.data?.reception_comment || "",

            delivery_number: event.data.delivery_number,
            batch_number: event.data.batch_number,

            weight_gross: event.data.weight_gross,
            weight_discount_nemrod: event.data.weight_discount_nemrod,
            weight_discount_vet: event.data.weight_discount_vet,
            weight_discount: event.data.weight_discount,
            amount: event.data.amount,

            unit_price: parseFloat(event.data.unit_price),
            linked: null,
            type: event.data.type,
          },
        };

        this.inputHuntingBatch = inputHuntingBatch;
        this.modalHuntingBatch.show();
        return;
      }
      if (event.action == "move-game-pickup-3") {
        let inputWildGame = {
          record_id: this.record._id,
          _id: event.data._id,
          id: event.data._id,
          action: "move-game-pickup-3",
          name: event.data.name,
          number: event.data.number,
          entity_id: this.record.entity_id,
          source: this.record.pickup_number,
        };

        this.inputWildGameMove = inputWildGame;

        this.modalWildGameMove.show();
        return;
      }
      if (event.action == "move-game-delivery-2") {
        let inputWildGame = {
          record_id: this.record._id,
          _id: event.data._id,
          id: event.data._id,
          action: "move-game-delivery-2",
          name: event.data.name,
          number: event.data.number,
          entity_id: this.record.entity_id,
          source: this.record.delivery_number,
        };

        this.inputWildGameMove = inputWildGame;

        this.modalWildGameMove.show();
        return;
      }
      if (event.action == "move-game-batch-2") {
        let inputVetoControlMove = {
          //  batch_number: this.record.name,
          record_id: this.record._id,
          _id: event.data._id,
          action: "move-game-batch-2",
          source: {
            _id: event.data._id,
            id: event.data._id,
            action: "move-game-batch-2",
            name: event.data.name,
            record_id: this.record._id,
            number: event.data.number,
            batch_number: this.record.batch_number,
            delivery_number: event.data.delivery_number,
            entity_id: this.record.entity_id,
            source: this.record.batch_number,
          },
        };

        this.inputVetoControlMove = inputVetoControlMove;
        this.refresh_veto = Math.random().toString(36).substring(7);
        this.modalVetoControlMove.show();
        return;
      }

      if (event.action == "delete-game-2" || event.action == "delete-hunting-batch-2" || event.action == "delete-item-from-batch-2" || event.action == "delete-item-from-pickup-2") {
        //   this.recordDelete = event.data
        //   this.modalDelete.show()
        let description =
          "<div><h3 class='my-3 text-2xl w-full text-center center font-bold'>Attention</h3><p></p><div class='px-2'>Le Gibier sera retiré du Bon d'Arrivage et ne sera pas associé à un Bon d'Arrivage.<br><br><strong class='text-red-800'>Cette action est définitive.</strong>.</div></div>";

        if (event.action == "delete-hunting-batch-2") {
          description =
            "<div><h3 class='my-3 text-2xl w-full text-center center font-bold'>Attention</h3><p></p><div class='px-2'>Le Gibier sera retiré du Lot et n'aura plus de lot associé.<br><br><strong class='text-red-800'>Cette action est définitive.</strong>.</div></div>";
        }
        if (event.action == "delete-item-from-pickup-2") {
          description =
            "<div><h3 class='my-3 text-2xl w-full text-center center font-bold'>Attention</h3><p></p><div class='px-2'>Le Gibier sera définitivement retiré du Bon de collecte.<br><br><strong class='text-red-800'>Cette action est définitive.</strong>.</div></div>";
        }

        let inputItemDelete = {
          id: this.record._id,
          item_id: event.data._id,
          name: event.data.number,
          active: false,
          count: null,
          root: event.action == "delete-game-ba-2" ? "ba" : "batch",
          action: event.action,
          title: "Gibier : " + event.data.name + " (Bague : " + event.data.number + ")",
          label: "Confirmer le numéro de la bague :",
          placeholder: "Numéro de la bague :",
          description: description,
        };
        this.inputItemDelete = inputItemDelete;
        this.modalItemDelete.show();
        return;
      }

      if (event.action == "delete-hunting-ba" || event.action == "delete-hunting-batch") {
        //   this.recordDelete = event.data
        //   this.modalDelete.show()

        let description =
          "<div><h3 class='my-3 text-2xl w-full text-center center font-bold'>Attention</h3><p></p><div class='px-2'>Le Gibier sera retiré du Bon d'Arrivage et ne sera pas associé à un Bon d'Arrivage.<br><br><strong class='text-red-800'>Cette action est définitive.</strong>.</div></div>";

        if (event.action == "delete-hunting-batch-2") {
          description =
            "<div><h3 class='my-3 text-2xl w-full text-center center font-bold'>Attention</h3><p></p><div class='px-2'>Le Gibier sera retiré du Lot et n'aura plus de lot associé.<br><br><strong class='text-red-800'>Cette action est définitive.</strong>.</div></div>";
        }

        let inputItemDelete = {
          id: this.record._id,
          item_id: event.data._id,
          name: event.data.number,
          active: false,
          count: null,
          root: event.action == "delete-hunting-ba" ? "ba" : "batch",
          action: "nemrod-delete-hunting-ba",
          title: "Gibier : " + event.data.name + " (Bague : " + event.data.number + ")",
          label: "Confirmer le numéro de la bague :",
          placeholder: "Numéro de la bague :",
          description: description,
        };
        this.inputItemDelete = inputItemDelete;
        this.modalItemDelete.show();
        return;
      }

      if (event.action == "add-game-batch-2") {
        let inputVetoControlMove = {
          //  batch_number: this.record.name,
          record_id: this.record._id,

          source: {
            _id: event.data._id,
            id: event.data._id,
            record_id: this.record._id,
            name: event.data.name,
            action: "add-game-batch-2",
            number: event.data.number,
            batch_number: "",
            delivery_number: this.record.delivery_number,
            entity_id: this.record.entity_id,
            source: this.record.delivery_number,
          },
        };

        this.inputVetoControlMove = inputVetoControlMove;

        this.modalVetoControlMove.show();
        return;
      }

      if (event.action == "add-control-veto") {
        let inputVetoControlMove = {
          //  batch_number: this.record.name,
          record_id: this.record._id,
          _id: event.data._id,
          id: event.data._id,
          name: event.data.name,
          action: "add-control-veto",
          number: event.data.number,
          batch_number: event.data.batch_number,
          delivery_number: event.data.delivery_number,
          entity_id: this.record.entity_id,
          source: this.record.delivery_number,
        };

        this.inputVetoControlMove = inputVetoControlMove;

        this.modalVetoControlMove.show();
        return;
      }

      if (event.action == "move-control-veto-from-reporting") {
        alert("Fonction pas encore disponible depuis les Bons d'Arrivage. Peut etre effectué depuis la vue des lots.");
      }

      if (event.action == "move-control-veto-2") {
        let inputVetoControlMove = {
          //  batch_number: this.record.name,
          record_id: this.record._id,
          _id: event.data._id,
          id: event.data._id,
          name: event.data.name,
          action: "move-control-veto-2",
          number: event.data.number,
          batch_number: event.data.batch_number,
          delivery_number: event.data.delivery_number,
          entity_id: this.record.entity_id,
          source: this.record.delivery_number,
        };

        this.inputVetoControlMove = inputVetoControlMove;

        this.modalVetoControlMove.show();
        return;
      }

      if (event.action == "move-hunting-ba") {
        let inputWildGame = {
          record_id: this.record._id,
          _id: event.data._id,
          id: event.data._id,
          name: event.data.name,
          number: event.data.number,
          entity_id: this.record.entity_id,
          source: this.record.delivery_number,
        };

        this.inputWildGameMove = inputWildGame;

        this.modalWildGameMove.show();
        return;
      }

      if (event.action == "show-wild-game") {
        let inputWildGame = {
          id: event.data.id,
          mode: "edit",
          name: event.data.name,
          veto_photos: event.data.veto_photos,
          nemrod_photos: event.data.nemrod_photos,

          description: event.data.description,
          default: event.data.default,
          linked: null,
          type: event.data.type,
        };
        this.inputWildGameEdit = inputWildGame;
        this.modalWildGameEdit.show();
        return;
      }

      if (event.action == "delete") {
        // let collection = "company-addresses"

        let collection = "data-sources/668e6a7467ca9aa206c55dda/records";

        await service.deleteRecord(collection, this.user?.token, event.data._id);
        let index = this.record?.addresses?.findIndex(function (a) {
          return a._id == event.data._id;
        });
        this.record?.addresses?.splice(index, 1);

        //     let response = await service.deleteRecord("company-addresses", this.user?.token, event.data._id)
        

        return;
      }

      if (event.action == "delete-user") {
        let collection = "data-sources/6642fa56a2b8d03824a74c9c/records";
        // let collection ="contacts"
        await service.deleteRecord(collection, this.user?.token, event.data._id);
        let index = this.record.contacts.findIndex(function (a) {
          return a._id == event.data._id;
        });
        this.record.contacts.splice(index, 1);

        //    let response = await service.deleteRecord(collection, this.user?.token, event.data._id)
        //    console.log(response)
        return;
      }

      if (event.action == "delete-attribute") {
        let index = this.record.items.findIndex(function (a) {
          return a._id == event.data._id;
        });
        this.record.items.splice(index, 1);
        return;
      }

      if (event.action == "delete-supplier") {
        let index = this.record?.items?.findIndex(function (a) {
          return a._id == event.data._id;
        });
        this.record?.items?.splice(index, 1);
        let source_id = "6655c723ce02a05e92113b9d"; // Liste des Fourniseurs
        let collection = "data-sources/" + source_id + "/records";
         await service.deleteRecord(collection, this.user?.token, event.data._id);
       
        return;
      }
    },
    OnAttributConfirm: async function (item) {
     
      if (this.record?.items == undefined) this.record.items = [];
      if (item.mode == "edit") {
        for (let i = 0; i < this.record.items.length; i++) {
          if (this.record.items[i]._id == item.id) {
            this.record.items[i] = item;
          }
        }
      }
      if (item.mode == "new") {
        let bfound = false;
        for (let i = 0; i < this.record.items.length; i++) {
          if (this.record.items[i].id == item.id) {
            bfound = true;
          }
        }
        if (bfound) {
          alert("Error The attribute " + item.id + " existe déja");
          return;
        }

        let index = this.record.items.push(item);
        console.log(index);
      }
      this.modalAttribut.hide();
    },
    OnSupplierConfirm: async function (item) {


      alert(JSON.stringify(item))
      if (item?.id == undefined) {
        if (this.record.items == undefined) this.record.items = [];

        item.company_id = this.record?._id;

        let source_id = "6655c723ce02a05e92113b9d"; // Liste des Fourniseurs
        let collection = "data-sources/" + source_id + "/records";

        //  item.name = this.record.name;

        delete item.id;
        item.product_id = this.record._id;

        let response = await service.addRecord(collection, this.user?.token, item);

        if (response != undefined) {
          if (response._id != undefined) {
            this.record.items.push(response);
 

            for (let i = 0; i < this.record.items.length; i++) {
              if (this.record.items[i]._id == response.id) {
                this.record.items[i]._id = response._id;
              }
            }

            //this.record.items.push(response)
            //     this.record.items[index]._id = response._id

            //  this.record.items[index].id = index;
            //    this.record.items[index]._id = response._id;
          } else {
            console.log("Error add");
 
          }
        }
      } else {
        for (let i = 0; i < this.record.items.length; i++) {
          if (this.record.items[i]._id == item.id) {
            item._id = item.id;
            this.record.items[i] = item;
          }
        }

        let source_id = "6655c723ce02a05e92113b9d"; // Liste des Fourniseurs
        let collection = "data-sources/" + source_id + "/records";
        await service.updateRecord(collection, item.id, this.user?.token, item);

        
      }
      this.modalSupplier.hide();
    },
    OnPostalAddressConfirm: async function (item) {
      if (item?.id == undefined) {
        item.debug = this.$route.params;
        if (this.record.addresses == undefined) this.record.addresses = [];
        let index = this.record.addresses.push(item);

        let collection = "data-sources/668e6a7467ca9aa206c55dda/records";
        // let collection = "company-addresses"
        item.company_id = this.$route.params.rid;

        let response = await service.addRecord(collection, this.user?.token, item);

        if (response != undefined) {
          if (response.insertedId != undefined) {
            this.record.addresses[index].id = index;
          } else {
            console.log("Error");
          }
        }
      } else {
        for (let i = 0; i < this.record.addresses.length; i++) {
          if (this.record.addresses[i]._id == item.id) {
            this.record.addresses[i] = item;
          }
        }
        let collection = "data-sources/668e6a7467ca9aa206c55dda/records";
        // let collection = "company-addresses"
         await service.updateRecord(collection, item.id, this.user?.token, item);
        
      }
      this.modalPostalAddress.hide();
    },
    OnContactManagementConfirm: async function (item) {
      if (item?.id == undefined) {
        if (this.record.contacts == undefined) this.record.contacts = [];
        let index = this.record.contacts.push(item);
        item.company_id = this.record?._id;

        let collection = "data-sources/6642fa56a2b8d03824a74c9c/records";
        let response = await service.addRecord(collection, this.user?.token, item);

        if (response != undefined) {
          if (response.id != undefined) {
            this.record.contacts[index - 1].id = response.id;
          } else {
            console.log("Error");
          }
        }
      } else {
        for (let i = 0; i < this.record.contacts.length; i++) {
          if (this.record.contacts[i].id == item.id) {
            this.record.contacts[i] = item;
          }
        }
        let collection = "data-sources/6642fa56a2b8d03824a74c9c/records";
        // let collection ="contacts"
        await service.updateRecord(collection, item.id, this.user?.token, item);
    
      }
      this.modalContentManagement.hide();
    },
    modalFieldDelete: async function (field) {
      if (confirm("Delete ?" + field.id + " (" + field.type + ")")) {
        if (field.type == "section") {
          for (let i = 0; i < this.template?.children?.length; i++) {
            let level1 = this.template?.children[i];
            for (let j = 0; j < level1?.body?.length; j++) {
              let level2 = level1.body[j];
              if (field.id == level2.id) {
                this.template.children.body.splice(i, j);
              }
            }
          }

          await service.updateRecord("ui-forms", this.template._id, this.user?.token, this.template);
          this.modalField.hide();
          return;
        } else if (field.type == "zone") {
          for (let i = 0; i < this.template?.children?.length; i++) {
            let level1 = this.template?.children[i];
            for (let j = 0; j < level1?.body?.length; j++) {
              let level2 = level1.body[j];
              for (let k = 0; k < level2?.items?.length; k++) {
                let level3 = level2.items[k];

                if (field.id == level3.id) {
                  this.template.children[i].body[j].items.splice(k, 1);
                }
              }
            }
          }

          await service.updateRecord("ui-forms", this.template._id, this.user?.token, this.template);
          this.modalField.hide();
          return;
        } else {
          for (let i = 0; i < this.template?.children?.length; i++) {
            let level1 = this.template?.children[i];

            for (let j = 0; j < level1?.body?.length; j++) {
              let level2 = level1.body[j];
              for (let k = 0; k < level2?.items?.length; k++) {
                let level3 = level2.items[k];

                for (let l = 0; l < level3?.items?.length; l++) {
                  let level4 = level3.items[l];

                  if (field.id == level4.id) {
                    delete this.template.children[i].body[j].items[k].items.splice(l, 1);
                  }
                }
              }

              //    if (this.template.items[i].items[j].id == field.id) {
              //        this.template.items[i].items[j].label.FR = "philippe"
              //    }
            }
          }
          await service.updateRecord("ui-forms", this.template._id, this.user?.token, this.template);
          this.modalField.hide();
          return;
        }
      }
    },
    modalFieldSave: async function (field) {
      if (field.id == "new") {
        if (field.type == "section") {
          for (let i = 0; i < this.template?.children?.length; i++) {
            let level1 = this.template?.children[i];
            if (field.tab == level1.id) {
              for (let j = 0; j < level1?.body?.length; j++) {
                let level2 = level1.body[j];

                if (level2.id == field.after) {
                  let section = {
                    id: uuidv4(),
                    title: {
                      FR: field.attributes.name,
                      EN: "EN--" + field.attributes.name,
                    },
                    class: field.attributes.class,
                    items: [],
                  };
                  level1.body.push(section);
                }
              }
            }
          }
        }
        if (field.type == "zone") {
          for (let i = 0; i < this.template?.children?.length; i++) {
            let level1 = this.template?.children[i];
            if (field.tab == level1.id) {
              for (let j = 0; j < level1?.body?.length; j++) {
                let level2 = level1.body[j];
                if (level2.id == field.section) {
                  for (let k = 0; k < level2?.items?.length; k++) {
                    let level3 = level2.items[k];

                    if (level3.id == field.after) {
                      let zone = {
                        id: uuidv4(),
                        title: {
                          FR: field.attributes.name,
                          EN: "EN--" + field.attributes.name,
                        },
                        class: field.attributes.class,
                        items: [],
                      };
                      level2.items.push(zone);
                    }
                  }
                }
              }
            }
          }
        }
        this.modalField.hide();
        return;
      }

      //  this.modalField.hide();
      //  return

      if (field.type == "section") {
        for (let i = 0; i < this.template?.children?.length; i++) {
          let level1 = this.template?.children[i];

          for (let j = 0; j < level1?.body?.length; j++) {
            let level2 = level1.body[j];

            if (field.id == level2.id) {
              if (this.template.children[i].body[j].title == undefined) this.template.children[i].body[j].title = {};
              this.template.children[i].body[j].title[this.lg] = field.attributes.name;
              this.template.children[i].body[j].class = field.attributes.class;
            }

            //    if (this.template.items[i].items[j].id == field.id) {
            //        this.template.items[i].items[j].label.FR = "philippe"
            //    }
          }
        }
        await service.updateRecord("ui-forms", this.template._id, this.user?.token, this.template);

        this.modalField.hide();
        return;
      } else if (field.type == "zone") {
        for (let i = 0; i < this.template?.children?.length; i++) {
          let level1 = this.template?.children[i];
          for (let j = 0; j < level1?.body?.length; j++) {
            let level2 = level1.body[j];
            for (let k = 0; k < level2?.items?.length; k++) {
              let level3 = level2.items[k];

              if (field.id == level3.id) {
                if (this.template.children[i].body[j].items[k].title == undefined) this.template.children[i].body[j].items[k].title = {};
                this.template.children[i].body[j].items[k].title[this.lg] = field.attributes.name;
                this.template.children[i].body[j].items[k].class = field.attributes.class;
              }
            }
          }
        }
        await service.updateRecord("ui-forms", this.template._id, this.user?.token, this.template);
        this.modalField.hide();
        return;
      } else {
        for (let i = 0; i < this.template?.children?.length; i++) {
          let level1 = this.template?.children[i];

          for (let j = 0; j < level1?.body?.length; j++) {
            let level2 = level1.body[j];
            for (let k = 0; k < level2?.items?.length; k++) {
              let level3 = level2.items[k];

              if (field.inside == level3.id) {
                let newfield = field.attributes;

                newfield.id = field.id;
                newfield.type = field.type;
                this.template.children[i].body[j].items[k].items.push(newfield);

                //PV Aligner le format de la structure
                return;
              }

              for (let l = 0; l < level3?.items?.length; l++) {
                let level4 = level3.items[l];

                if (field.after == level4.id) {
                  let arr = this.template.children[i].body[j].items[k].items;

                  //PV Aligner le format de la structure
                  field.attributes.id = field.id;
                  field.attributes.type = field.type;

                  let newItems = [
                    // part of the array before the specified index
                    ...arr.slice(0, l + 1),
                    // inserted item
                    field.attributes,
                    // part of the array after the specified index
                    ...arr.slice(l + 1),
                  ];
                  this.template.children[i].body[j].items[k].items = newItems;
                  await service.updateRecord("ui-forms", this.template._id, this.user?.token, this.template);

                  this.modalField.hide();
                  return;
                } else if (field.id == level4.id) {
                  if (field?.attributes?.source_id) this.template.children[i].body[j].items[k].items[l].source_id = field.attributes.source_id;
                  if (this.template.children[i].body[j].items[k].items[l].label == undefined) this.template.children[i].body[j].items[k].items[l].label = {};

                  this.template.children[i].body[j].items[k].items[l].label = field.attributes.label;
                  this.template.children[i].body[j].items[k].items[l].class = field.attributes.class;
                  this.template.children[i].body[j].items[k].items[l].data = field.attributes.data;
                  if (field.attributes?.source != undefined) this.template.children[i].body[j].items[k].items[l].source = field.attributes.source;

                  if (field.attributes?.format != undefined) this.template.children[i].body[j].items[k].items[l].format = field.attributes.format;
                  if (field.attributes?.unit != undefined) this.template.children[i].body[j].items[k].items[l].unit = field.attributes.unit;
                  if (field.attributes?.collection != undefined) this.template.children[i].body[j].items[k].items[l].collection = field.attributes.collection;
                  if (field.attributes?.filter != undefined) this.template.children[i].body[j].items[k].items[l].filter = field.attributes.filter;

                  if (field.attributes?.template != undefined) this.template.children[i].body[j].items[k].items[l].template = field.attributes.template;

                  if (field.attributes?.subdata != undefined) this.template.children[i].body[j].items[k].items[l].subdata = field.attributes.subdata;

                  if (field.attributes?.image_url != undefined) this.template.children[i].body[j].items[k].items[l].image_url = field.attributes.image_url;
                  if (field.attributes?.image_class != undefined) this.template.children[i].body[j].items[k].items[l].image_class = field.attributes.image_class;
                  if (field.attributes?.text_class != undefined) this.template.children[i].body[j].items[k].items[l].text_class = field.attributes.text_class;
                }
              }
            }

            //    if (this.template.items[i].items[j].id == field.id) {
            //        this.template.items[i].items[j].label.FR = "philippe"
            //    }
          }
        }
      }
      await service.updateRecord("ui-forms", this.template._id, this.user?.token, this.template);
      this.modalField.hide();
    },
    async onGeneratePDFReport() {
      //   let id = "6665ce28fcec2d05a4a97fbb"
      let id = "664303fda2b8d03824a74caa";
      let url = "data-sources/" + id + "/pdf/" + this.$route.params.rid;
      let records = await service.getData(url, this.user?.token, {});
      let blob = new Blob([records], { type: "application/pdf" });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
 
      link.download = "file.pdf";
      link._target = "_blank";
      link.click();
    },
    generateItem: function (type) {
      if (type == "text")
        return {
          id: uuidv4(),
          label: {
            FR: "Titre ......",
            EN: "Titre ......",
          },
          placeholder: {
            EN: "",
            FR: "",
          },
          data: "attribute",
          type: "text",
          class: "w-6/12   text-gray-800 justify-start",
          format: "text",
          unit: "",
        };

      if (type == "blank")
        return {
          id: uuidv4(),

          type: "blank",
          class: "w-4/12",
        };

      if (type == "display")
        return {
          id: uuidv4(),
          label: {
            EN: "Title ...",
            FR: "Titre ...",
          },
          template: "",
          type: "display",
          format: "text",
          class: "w-full",
        };

      if (type == "selectCollection")
        return {
          id: uuidv4(),
          label: {
            FR: "Titre ......",
            EN: "Titre ......",
          },
          placeholder: {
            EN: "",
            FR: "",
          },
          filters: {},
          data: "attribute",
          mode: "collection",
          collection: "",
          source: "",
          type: "selectCollection",
          class: "w-6/12  text-gray-800 justify-start",
        };

      if (type == "tag")
        return {
          id: uuidv4(),
          label: {
            FR: "Titre ......",
            EN: "Titre ......",
          },
          placeholder: {
            EN: "",
            FR: "",
          },
          data: "attribute_tag",
          type: "tag",
          source: "material-type",
          class: "w-6/12  text-gray-800 justify-start",
        };

      return {
        id: uuidv4(),
        label: {
          FR: "Titre ......",
          EN: "Titre ......",
        },
        placeholder: {
          EN: "",
          FR: "",
        },
        data: "attribute",
        type: "text",
        class: "w-6/12   text-gray-800 justify-start",
        format: "text",
        unit: "",
      };
    },
    modalAddFieldOpen: function (item) {
 
      if (item.type == "") {
        return;
      }
      this.empty = this.generateItem(item.type);
      this.empty.after = item.after?.id;
      this.empty.inside = item.inside;
      this.modalField.show();
    },
    modalFieldOpen: function (item) {
      this.empty = item;
      this.empty.after = null;
      this.modalField.show();
    },
    modalPostalAddressOpen: function (config) {
      this.empty = config;
      this.modalPostalAddress.show();
    },
    modalContactManagementOpen: function (config) {
      this.empty = config;
      this.modalContactManagement.show();
    },
    onDeleteField: async function (field) {
      for (let i = 0; i < this.template?.children?.length; i++) {
        let level1 = this.template?.children[i];

        for (let j = 0; j < level1?.body?.length; j++) {
          let level2 = level1.body[j];
          for (let k = 0; k < level2?.items?.length; k++) {
            let level3 = level2.items[k];

            for (let l = 0; l < level3?.items?.length; l++) {
              let level4 = level3.items[l];

              if (field.id == level4.id) {
                this.template?.children[i].body[j].items[k].items.splice(l, 1);
                await service.updateRecord("ui-forms", this.template._id, this.user?.token, this.template);
                return;
              }
            }
          }
        }
      }
    },
    changeFieldParameter: function (/*field*/) {},
    onValueChanged(event) {
      let r = flatten(this.record);
      r[event.id] = event.value;
      this.record = unflatten(r);

      //TODO : Vérrue pour "Actors"
      if (event.id == "team_id") {
        //On change le job_ud si changement de team_id

        if (event.mode == 0) this.record.job_id = "";

        this.customAction = {
          timestamp: new Date(),
          attribut: "job_id",
          value: "",
        };
      }
    },

    async onAction(event) {

     // alert(event.type)


      switch (event.type) {
        case "manufacturing-process-add-step":
          {
            this.onCreateManufacturingProcessStep(event);
          }
          break;
        case "manufacturing-process-edit-step":
          {
            this.onEditManufacturingProcessStep(event);
          }
          break;
        case "manufacturing-process-delete-step":
          {
            this.onOpenDeleteManufacturingProcessStep(event);
          }
          break;

        case "manufacturing-step-creation":
          {
            this.onOpenCreateSection(event);
          }
          break;

        case "manufacturing-process-delete-section":
          {
            this.onOpenDeleteManufacturingProcessSection(event);
          }
          break;

        case "manufacturing-process-edit-section":
          {
            this.onOpenEditSection(event);
          }
          break;

        //      case "manufacturing-step-edition":
        //        {

        //        }
        //        break;
        case "nemrod-update-ivat-rate":
          {
            let properties = {
              record_id: event.record_id,
              decision: event.decision,
              type: event.type,
            };

            let response = await service.runFunctionV2("nemrod-update-ivat-rate", properties, this.user?.token);
       
            this.addToast(response?.message, "success");

            this.record.state = response.record.state;
            this.record.amount_ivat = response.record.amount_ivat;
            this.record.amount_with_ivat = response.record.amount_with_ivat;
            this.record.amount_without_ivat = response.record.amount_without_ivat;
            this.record.ivat_rate = response.record.ivat_rate;
            this.record.message = response.record.message;
            this.record.amount_to_pay = response.record.amount_to_pay;

            // this.record = response?.record;

            //  await this.loadPageRecord();
          }
          break;

        case "generate-game-invoice":
          {
            let properties = {
              record_id: this.record._id,
            };

            let response = await service.runFunctionV2("nemrod-generate-invoice", properties, this.user?.token);

            if (response?.status == "OK") {
              this.record.state = response.record.state;
              this.record.invoice_number = response.record.invoice_number;
              this.record.amount_to_pay = response.record.amount_to_pay;
            }
          }
          break;

        case "generate-game-invoice-pdf":
          {
            let properties = {
              record_id: this.record._id,
            };

            let response = await service.runFunctionV2("nemrod-generate-invoice-pdf", properties, this.user?.token);

            if (response?.status == "OK") {
              //  this.record.state = response.record.state;
              // this.record.invoice_number = response.record.invoice_number;
              //this.record.amount_to_pay = response.record.amount_to_pay;
            }
          }
          break;

        case "google-full-synchro":
          {
            let properties = {
              action: "google-full-synchro",

              forced_mode: event.forced_mode,
            };

            let response = await service.runFunctionV2("nemrod-google-drive", properties, this.user?.token);

            if (response?.status == "OK") {
              if (response?.message != null) this.addToast(response?.message, "success");
              await this.loadPageRecord();
            } else {
              this.addToast(response?.message, "error");
            }
          }
          break;

        case "generate-ba-pdf":
          {
            this.inputSendEmailsGeneratePdf = {
              emails: this.record?.emails,
              mode: "send-generate-pdf-only",
              document: "delivery",
            };

            this.modalSendMailsGeneratePdf.show();

            /*
            let properties = {
              record_id: this.record._id,
              generate_pdf: true,
              send_to: [],
            };

            let response = await service.runFunctionV2("nemrod-generate-pdf-game-delivery-note", properties, this.user?.token);

            if (response?.status == "OK") {
              // this.record.state = response.record.state
              /// this.record.invoice_number = response.record.invoice_number
              // this.record.amount_to_pay = response.record.amount_to_pay
            }*/
          }
          break;
        case "generate-batch-pdf":
          {
            this.inputSendEmailsGeneratePdf = {
              emails: this.record?.emails,
              mode: "send-generate-pdf-only",
              document: "batch",
            };

            this.modalSendMailsGeneratePdf.show();

            /*
            let properties = {
              record_id: this.record._id,
            };

            let response = await service.runFunction("nemrod-generate-batch-pdf", properties, this.user?.token);

            if (response?.status == "OK") {
              // this.record.state = response.record.state
              /// this.record.invoice_number = response.record.invoice_number
              // this.record.amount_to_pay = response.record.amount_to_pay
            }*/
          }
          break;

        case "send-mail-batch":
          {
            this.inputSendEmailsGeneratePdf = {
              emails: this.record?.emails,
              mode: "send-emails-only",
              document: "batch",
            };
            this.modalSendMailsGeneratePdf.show();
            this.$nextTick(() => {});
          }
          break;

        case "send-mail":
          {
            this.inputSendEmailsGeneratePdf = {
              emails: this.record?.emails,
              mode: "send-emails-only",
              document: "delivery",
            };

            this.modalSendMailsGeneratePdf.show();

            this.$nextTick(() => {});
          }
          break;
        case "generate-pdf":
          {
            let data = {
              id: event.id,
            };
            service.GeneratePdf(this.$route.params.rid, event.collection, data, this.user?.token);
          }
          break;
        case "change-pincode":
          {
            if (event.pincode.length != 4) {
              this.message_alert = this.$t("FORMVIEW_ERROR_PINCODE_LENGTH");
              this.displayAlert();
              return;
            }
            let item = {
              id: event.id,
              pincode: event.pincode,
            };
            let response = await service.ChangeUserPincode(item, this.user?.token);

            if (response.status == "OK") {
              this.displayConfirmation();
            } else {
              this.message_alert = this.$t("FORMVIEW_EXPECTED_ERROR");
              this.displayAlert();
            }
          }
          break;
        case "send-invitation":
          {
            let item = {
              tenant: "xx",
              email: event.email,
            };
            let response = await service.sendInvitationMail(item, this.user?.token);

            if (response.status == "OK") this.displayConfirmation();
            else {
              this.message_alert = this.$t("FORMVIEW_EXPECTED_ERROR");
              this.displayAlert();
            }
          }
          break;
        case "reset-password":
          {
            let item = {
              tenant: "xx",
              email: event.email,
            };
            let response = await service.ResetPassword2(item, this.user?.token);

            if (response?.status == "OK") this.displayConfirmation();
            else {
              this.message_alert = this.$t("FORMVIEW_EXPECTED_ERROR");
              this.displayAlert();
            }
          }
          break;
        case "activate-portal-user":
          {
            let item = {
              actor_id: event.actor_id,
              first_name: event.first_name,
              last_name: event.last_name,
              login: event.login,
              email: event.email,
            };
            let response = await service.ActivateUser(item, this.user?.token);

            if (response?.status == "OK") this.displayConfirmation();
            else {
              this.message_alert = this.$t("FORMVIEW_EXPECTED_ERROR");
              this.displayAlert();
            }

            this.record["portal-state"] = "PENDING-ACTIVATION";
          }

          break;
      }
    },
    OnAddImage() {
      this.surveyModal.hide();
    },
    async onMenuSelected(event) {



  //alert(event.action)


      if (event.action == "duplicate-common") {
        if (this.datasource_id == undefined) {
          // this.$router.push("/error")
          if (this.back) this.$router.push("/error");
          else this.$router.push("/");
          return;
        }

        let collection = "data-sources/" + this.datasource_id;

        let record = await service.duplicateRecord(collection, this.user?.token, this.$route.params.rid);
        let root = "/admin/views";
        let url = root + "/" + this.$route.params.id + "/" + record.insertedId;
        //  if (url.indexOf("?") == -1) url += "?back=" + this.$router.currentRoute?._rawValue?.fullPath;
        //  else url += "&back=" + this.$router.currentRoute?._rawValue?.fullPath;

        url = url + "?tab=product-yoghurt&category=product-yoghurt&page=1";
        window.location = url;
      }

      // if (event.action == "delete-common") {

      // }

      if (event.action == "edit-delivery-report-2") {
        let inputDeliveryReport = {
          id: this.record._id,
          pricing_catalog_id: this?.record?.pricing_catalog_id,
          delivery_number: this?.record?.delivery_number,
          action: event.action,
          mode: "display",
          source: {
            item_id: this.record._id,
            type: this.record.type,
            number: this.record.number,
            member_id: this.record.received_by_id,
            entity_id: this.record.entity_id,
            mode: "display",
            pricing_catalog_id: this?.record?.pricing_catalog_id,
            temperature: this.record.temperature,
            temperature_unit: this.record.temperature_unit,
            hunter_id: this.record.supplier_id,
          },
        };
        this.inputDeliveryReport = inputDeliveryReport;
        this.modalDeliveryReport.show();
        return;
      }

      if (event.action == "edit-pickup-note-2") {
        let inputPickupReport = {
          id: this.record._id,

          pickup_number: this?.record?.pickup_number,
          action: event.action,
          mode: "display",
          source: {
            item_id: this.record._id,
            type: this.record.type,
            number: this.record.number,
            member_id: this.record.pickup_by_id,
            entity_id: this.record.entity_id,
            mode: "display",
            hunter_id: this.record.supplier_id,
          },
        };
        this.inputPickupReport = inputPickupReport;
        this.modalPickupReport.show();
        return;
      }

      if (event.action == "update-game-batch-report-2") {
        let inputBatchReportUpdate = {
          id: this.record._id,
          batch_number: this.record.name,
          mode: "display",
          source: {
            mode: "display",
            action: "edit-batch-report-2",
            controlled_at: this.record.controlled_at,
            controlled_by_id: this.record.controlled_by_id,
            reviewed_by_id: this.record.reviewed_by_id,

            batch_number: this.record.batch_number,
            entity_id: this.record.entity_id,
          },
        };
        this.inputBatchReportUpdate = inputBatchReportUpdate;
        this.modalBatchReportUpdate.show();
        return;
      }

      if (event.action == "update-game-batch-number") {
        let entity_id = this.record.entity_id;

        if (Array.isArray(entity_id)) entity_id = entity_id[0];

        let inputBatchNumberUpdate = {
          id: this.record._id,
          batch_number: this.record.name,
          mode: "display",
          source: {
            mode: "display",
            action: "edit-batch-number",
            controlled_at: this.record.controlled_at,
            controlled_by_id: this.record.controlled_by_id,
            reviewed_by_id: this.record.reviewed_by_id,

            batch_number: this.record.batch_number,
            entity_id: entity_id,
          },
        };
        this.inputBatchNumberUpdate = inputBatchNumberUpdate;
        this.modalBatchNumberUpdate.show();
        return;
      }

      if (event.action == "change-game-delivery-number") {
        let entity_id = this.record.entity_id;

        let received_at = this.record.received_at;

        received_at = received_at.split("T")[0];

        if (Array.isArray(entity_id)) entity_id = entity_id[0];

        let inputDeliveryNumberUpdate = {
          id: this.record._id,
          delivery_number: this.record.delivery_number,
          received_at: received_at,
          mode: "display",
          source: {
            mode: "display",
            action: "edit-delivery-number",
            received_at: this.record.received_at,
            batch_number: this.record.batch_number,
            entity_id: entity_id,
          },
        };
        this.inputDeliveryNumberUpdate = inputDeliveryNumberUpdate;
        this.modalDeliveryNumberUpdate.show();
        return;
      }

      if (event.action == "edit-delivery-report") {
        let inputDeliveryReport = {
          id: this.record._id,
          price_catalog_name: this?.record?.price_catalog?.name,
          price_catalog_id: this?.record?.price_catalog?._id,
          mode: "edit",
          delivery_number: this?.record?.delivery_number,
          action: event.action,
          source: {
            item_id: this.record._id,
            type: this.record.type,
            number: this.record.number,

            member_id: this.record.received_by_id,
            pricing_catalog_name: this?.record?.price_catalog?.name,
            pricing_catalog_id: this?.record?.price_catalog?._id,
            temperature: this.record.temperature,
            temperature_unit: this.record.temperature_unit,
            hunter_id: this.record.supplier_id,
          },
        };

        this.inputDeliveryReport = inputDeliveryReport;
        this.modalDeliveryReport.show();
        return;
      }

      if (event.action == "calculate-amounts") {
        alert("Bientôt disponible");
      }
      if (event.action == "create-receiving-report") {
        alert("Bientôt disponible");
      }

      if (event.action == "generate-ba-pdf") {
        let properties = {
          record_id: this.record._id,
        };

        let response = await service.runFunction("nemrod-generate-receiving-report-pdf", properties, this.user?.token);

        if (response?.status == "OK") {
          // this.record.state = response.record.state
          /// this.record.invoice_number = response.record.invoice_number
          // this.record.amount_to_pay = response.record.amount_to_pay
        }
      }

      if (event.action == "generate-batch-pdf") {
        let properties = {
          record_id: this.record._id,
        };

        let response = await service.runFunction("nemrod-generate-batch-pdf", properties, this.user?.token);

        if (response?.status == "OK") {
          // this.record.state = response.record.state
          /// this.record.invoice_number = response.record.invoice_number
          // this.record.amount_to_pay = response.record.amount_to_pay
        }
      }

      if (event.action == "generate-game-invoice") {
        /*
        let properties = {
          record_id: this.record._id,
        };

        let response = await service.runFunction("nemrod-generate-game-invoice", properties, this.user?.token);

        if (response?.status == "OK") {
          this.record.state = response.record.state;
          this.record.invoice_number = response.record.invoice_number;
          this.record.amount_to_pay = response.record.amount_to_pay;
        }
*/

        let properties = {
          record_id: this.record._id,
        };

        let response = await service.runFunctionV2("nemrod-generate-invoice", properties, this.user?.token);

        if (response?.status == "OK") {
          this.record.state = response.record.state;
          this.record.invoice_number = response.record.invoice_number;
          this.record.amount_to_pay = response.record.amount_to_pay;
        }
      }

      if (event.action == "back-draft-invoice") {
        let properties = {
          record_id: this.record._id,
        };

        let response = await service.runFunction("nemrod-back-draft-invoice", properties, this.user?.token);

        if (response?.status == "OK") {
          this.record.state = response.record.state;
          this.record.message = response.record.message;

          this.record.invoice_number = response.record.invoice_number;
          this.record.amount_to_pay = response.record.amount_to_pay;
        }
      }

      if (event.action == "pay-game-invoice") {
        let properties = {
          record_id: this.record._id,
        };

        let response = await service.runFunction("nemrod-pay-game-invoice", properties, this.user?.token);

        if (response?.status == "OK") {
          console.log("refresh");
          this.record.state = response.record.state;
          this.record.invoice_number = response.record.invoice_number;
          this.record.amount_to_pay = response.record.amount_to_pay;
          this.addToast(response?.message, "success");
        }
      }

      if (event.action == "batch-number-change") {
        let inputBatchReportUpdate = {
          id: this.record._id,
          batch_number: this.record.name,
        };
        this.inputBatchReportUpdate = inputBatchReportUpdate;
        this.modalBatchReportUpdate.show();
        return;
      }

      if (event.action == "delete-receiving-report") {
        let inputItemDelete = {
          id: this.record._id,
          name: this.record.delivery_number,
          count: this.record.items?.length,
          action: "nemrod-delete-receiving-report",
          title: "Numéro du Bon d'Arrivage : " + this.record.delivery_number,
          label: "Confirmer le numéro du bon a supprimer :",
          error:
            "<div class='flex justify-center h-16 items-center w-full'>La suppression du Bon d'arrivage n'est pas possible car du gibier reste associé à ce Bon d'Arrivage. Vous devez d'abord déplacer le Gibier dans d'autres Bons d'Arrivage ou les supprimer.</div>",
          description: "<div> <p></p><div class='px-2 text-lg flex items-center'>Pour supprimer ce Bon d'arrivage, vous devez saisir le numéro du bon d'arrivage. L'action est définitive.</div></div>",
        };
        this.inputItemDelete = inputItemDelete;
        this.modalItemDelete.show();
        return;
      }

      if (event.action == "delete-game-delivery-report-2") {
        let inputItemDelete = {
          id: this.record._id,
          name: this.record.delivery_number,
          count: this.record.items?.length,
          action: "delete-game-delivery-report-2",
          title: "Numéro du Bon d'Arrivage : " + this.record.delivery_number,
          label: "Confirmer le numéro du bon a supprimer :",
          error:
            "<div class='flex justify-center h-24 items-center w-full'>La suppression du Bon d'arrivage n'est pas possible car du gibier reste associé à ce Bon.<br>Vous devez d'abord déplacer le Gibier dans d'autres Bons d'Arrivage ou les supprimer.</div>",
          description: "<div> <p></p><div class='px-2 text-lg flex items-center'>Pour supprimer ce Bon d'arrivage, vous devez saisir le numéro du bon d'arrivage. L'action est définitive.</div></div>",
        };
        this.inputItemDelete = inputItemDelete;
        this.modalItemDelete.show();
        return;
      }

      if (event.action == "delete-game-pickup-note-2") {
        let inputItemDelete = {
          id: this.record._id,
          name: this.record.pickup_number,
          count: this.record.items?.length,
          action: "delete-game-pickup-note-2",
          title: "Numéro du Bon de Collecte : " + this.record.pickup_number,
          label: "Confirmer le numéro du bon a supprimer :",
          error:
            "<div class='flex justify-center h-16 items-center w-full'>La suppression du Bon d'arrivage n'est pas possible car du gibier reste associé à ce Bon de Collecte. Vous devez d'abord déplacer le Gibier dans d'autres Bons de Collect ou les supprimer.",
          description: "<div> <p></p><div class='px-2 text-lg flex items-center'>Pour supprimer ce Bon d'arrivage, vous devez saisir le numéro du bon d'arrivage. L'action est définitive.</div></div>",
        };
        this.inputItemDelete = inputItemDelete;
        this.modalItemDelete.show();
        return;
      }

      //PV1024

      if (event.action == "edit-game-item") {
        if (this.record.reception_state == undefined) this.record.reception_state = "OK";

        let inputHuntingBatch = {
          id: this.record._id,
          price_catalog_name: this?.record?.pricing_delivery_name,
          price_catalog_id: this?.record?.pricing_delivery_id,
          mode: "edit",
          action: event.action,
          source: {
            item_id: this.record._id,

            name: this.record.name,
            reference: this.record.reference,
            number: this.record.number,
            state: this.record.state,

            species_id: this.record?.species_id,

            vet_state: this.record?.vet_state,
            vet_comment_id: this.record?.vet_comment_id,
            vet_comment: this.record?.vet_comment,

            nemrod_state: this.record?.nemrod_state,
            nemrod_comment_id: this.record.nemrod_comment_id,
            nemrod_comment: this.record.nemrod_comment,

            reception_state: this.record.reception_state,
            reception_comment_id: this.record.reception_comment_id || "",
            reception_comment: this.record.reception_comment || "",

            skinning_state: this.record.skinning_state || "OK",
            skinning_comment_id: this.record.skinning_comment_id || "",
            skinning_comment: this.record.skinning_comment || "",

            pickup_number: this.record.pickup_number,
            delivery_number: this.record.delivery_number,
            batch_number: this.record.batch_number,

            pickup_id: this.record.pickup_id,
            delivery_id: this.record.delivery_id,
            batch_number_id: this.record.batch_id,

            batches: this.record.batches,

            weight_gross: { value: this.record.weight_gross_value, unit: "kg" },
            weight_discount_nemrod: { value: this.record.weight_discount_nemrod_value, unit: "kg" },
            weight_discount_vet: { value: this.record.weight_discount_vet_value, unit: "kg" },
            weight_discount: { value: this.record.weight_discount_value, unit: "kg" },
            amount: this.record.amount,

            unit_price: this.record.unit_price,
            linked: null,
            type: this.record.type,
          },
        };

        this.inputHuntingBatch = inputHuntingBatch;
        this.modalHuntingBatch.show();
        return;
      }

      if (event.action == "delete-game-item-3") {
        let inputItemDelete = {
          id: this.record._id,
          name: this.record.number,
          count: 0,
          action: "delete-game-item-3",
          title: "Numéro du Gibier : " + this.record.number,
          label: "Confirmer le numéro du gibier a supprimer :",
          error: "",
          description: "<div> <p></p><div class='px-2 text-lg flex items-center'>Pour supprimer ce Gibier, vous devez saisir le numéro du bon d'arrivage. L'action est définitive.</div></div>",
        };
        this.inputItemDelete = inputItemDelete;
        this.modalItemDelete.show();
        return;
      }

      if (event.action == "delete-game-batch-2") {
        let inputItemDelete = {
          id: this.record._id,
          action: "delete-game-batch-2",
          name: this.record.batch_number,
          count: this.record.items?.length,
          title: "Numéro de lot : " + this.record.batch_number,
          error: "Vous ne pouvez pas supprimer un lot<br>si du Gibier est encore associé.",
          label: "Confirmer le numéro de lot a supprimer :",
          description:
            "<div><h3 class='my-3 text-2xl w-full text-center center font-bold'>Attention</h3><p></p><div class='px-2'>En confirmant la suppression d'un numéro du lot sera <strong>définitive</strong>.</div></div>",
        };
        this.inputItemDelete = inputItemDelete;
        this.modalItemDelete.show();
        return;
      }
      if (event.action == "delete-game-batch") {
        let inputItemDelete = {
          id: this.record._id,
          action: "nemrod-delete-game-batch",
          name: this.record.number,
          count: this.record.items?.length,
          title: "Numéro de lot : " + this.record.number,
          error: "Vous ne pouvez pas supprimer un lot<br>si du Gibier est encore associé a ce lot",
          label: "Confirmer le numéro de lot a supprimer :",
          description:
            "<div><h3 class='my-3 text-2xl w-full text-center center font-bold'>Attention</h3><p></p><div class='px-2'>En confirmant la suppression d'un numéro de lot, les arrivages & contrôles associés seront également <strong>supprimés</strong>.</div></div>",
        };
        this.inputItemDelete = inputItemDelete;
        this.modalItemDelete.show();
        return;
      }

      if (event.action == "hunter-change") {
        let inputHunterChange = {
          id: this.record._id,
          company_id: this.record.company._id,
          name: this.record.company.name,
          city: this.record?.company?.main_address?.city,
          reference: this.record.company.reference,

          image_id: this.record.company.image_id,
          // id: event.data.id,
          // _id: event.data._id,
          // name: event.data.name,
          // number: event.data.number,
          entity_id: this.record.entity_id,
          // source: this.record.delivery_number
        };

        this.inputHunterChange = inputHunterChange;

        this.modalHunterChange.show();
        return;
      }
    },
    onChangeRoot(index) {
      this.currentImageIndex = index;
    },
    displayTitle() {
      if (this.template == undefined) return "";
      if (this.template.title == undefined) return "";
      if (this.lg == undefined) return "";

      Handlebars.registerHelper("eq", function (a, b) {
        return a === b;
      });

      Handlebars.registerHelper("dateFormat", function (options) {
        //return options.fn(this);

        if (options.fn(this) == undefined) return "-";
        if (options.fn(this) == "") return "-";
        if (options.fn(this) == "-") return "-";

        let da = options.fn(this).split("T");

        let d = new Date(da[0]);
        let m = ("0" + (d.getMonth() + 1)).slice(-2);
        let day = ("0" + d.getDate()).slice(-2);

        return new Handlebars.SafeString(day + "/" + m + "/" + d.getFullYear());
      });

      Handlebars.registerHelper("datetimeFormat", function (options) {
        //return options.fn(this);

        if (options.fn(this) == undefined) return "";
        if (options.fn(this) == "") return "";
        let d = new Date(options.fn(this));
        let m = ("0" + (d.getMonth() + 1)).slice(-2);
        let day = ("0" + (d.getDay() + 1)).slice(-2);
        let hour = ("0" + (d.getHours() + 1)).slice(-2);
        let minute = ("0" + (d.getMinutes() + 1)).slice(-2);

        return new Handlebars.SafeString(day + "/" + m + "/" + d.getFullYear() + " à " + hour + ":" + minute);
      });

      if (this.template?.title[this.lg] == undefined) {
        return "";
      }

      const template = Handlebars.compile(this.template?.title[this.lg]);
      let t = template(this.record);
      //return  t + "";
      return t; //this.template?.title[this.lg]  + "---"
    },
    displaySubTitle() {
      if (this.template == undefined) return "";
      if (this.template.title == undefined) return "";
      if (this.lg == undefined) return "";
      if (this.template?.subtitle == undefined) return "";

     
      const template = Handlebars.compile(this.template?.subtitle[this.lg]);
      let t = template(this.record);
      return t + "";
    },
    OnGenerateSheetOld() {
      this.generateSheetModal.show();
    },
    OnDisplaySheet() {
      let url = "/admin/pdf/display/" + this.$route.params.rid;
      window.location = url;
    },
    OnGenerateSheet(data) {
      //  window.location = "https://generate-pdf-seven.vercel.app/generate/"+ id
      // window.location =
      let langage = "fr";
      let market = "EU";

      if (data.market == "eu-en") {
        langage = "en";
        market = "EU";
      }

      if (data.market == "us-en") {
        langage = "en";
        market = "US";
      }

      if (data.market == "au-en") {
        langage = "en";
        market = "AU";
      }

      let url = "/admin/pdf/" + this.$route.params.rid + "?market=" + market + "&langage=" + langage;
      window.location = url;
      // window.open(url, this.$route.params.rid)

      //this.$router.push(url)

      // window.open("https://seashell-app-rrlf8.ondigitalocean.app/generate/" + this.$route.params.rid+"?market=" +data.market, this.$route.params.rid);
    },
    OnGenerateSheetClose() {
      this.generateSheetModal.hide();
    },
    OnGenerateSheetGenerate() {
      this.generateSheetModal.hide();
    },
    OnGenerateSheetConfirm() {
      this.generateSheetModal.hide();
    },
    onSelectFile(image) {
      this.record[this.currentImageField] = {
        name: image.name,
        url: "https://file-storage-ten.vercel.app/b4food/files/" + image.id,
      };

      this.surveyModal.hide();
    },
    onSelectImage(image) {
      this.record[this.currentImageField] = image.id;
      if (image.action == "close") {
        let timer = setTimeout(() => {
          clearTimeout(timer);
          this.surveyModal.hide();
        }, 200);
      }
    },
    onSelectImageModalOpen: function (item) {
      this.currentImageField = item;
      this.currentImageIndex = null;
      this.surveyModal.show();
    },
    OnSelectImageModalClose: function () {
      this.surveyModal.hide();
    },
    onCancel() {
      if (this.back) {
        this.$router.push(this.back);

        //   window.location = this.back;
        return;
      }

      if (this.template) {
        if (this.template.back) {
          if (this.template.back.link) {
            this.$router.push(this.template.back.link);
            //   window.location = this.template.back.link;
            return;
          }
        }
      }

      let url = "/admin/views/" + this.$route.params.id;
      window.location = url;
    },
    async onDelete(item) {
      //let collection  this.$route.params.id;

      let collection = "data-sources/" + this.template?.source_id + "/records";

      //let response =
      await service.deleteRecord(collection, this.user?.token, item._id);
      this.onCancel();
    },
    async onSave(item) {
      if (this.$route.params.rid == "new") {
        let collection = this.$route.params.id;
        if (this.template.endpoint != undefined) collection = this.template.endpoint;
        if (collection != "select-values") {
          //A Revoir
          if (this.$route.query.template) {
            item.category = this.$route.query.template;
          } else {
            //A revoir
            item.category = this.$route.params.id;
          }
        }

        if (collection == "raw-products") {
          if (this.$route.query.category) {
            item.category = this.$route.query.category;
          } else {
            //A revoir
            item.category = "raw-materials";
          }
        }

        collection = "data-sources/" + this.template.source_id + "/records";

        let response = await service.addRecord(collection, this.user?.token, item);

        if (response != undefined) {
          if (response.insertedId != undefined) {
            //  this.$router.push("/admin/views/" + this.$route.params.id + "/" + response.insertedId)

 
            this.$router.push("/admin/views/" + this.$route.params.id + "/" + response.insertedId);
            // window.location = "/admin/views/" + this.$route.params.id + "/" + response.insertedId
          } else {
 
            this.$router.push("/admin/views/" + this.$route.params.id + "/" + response._id);

            // this.$router.push("/admin/views/" + this.$route.params.id + "/" + response._id)
            // window.location = "/admin/views/" + this.$route.params.id + "/" + response._id
          }
        } else {
          this.message_alert = this.$t("FORMVIEW_EXPECTED_ERROR");
          this.displayAlert();
        }
      } else {
        let itemunflatten = unflatten(item);
        //let response =

        //PV

        let collection = "data-sources/" + this.template?.source_id + "/records";
        await service.updateRecord(collection, this.$route.params.rid, this.user?.token, itemunflatten);
        // await service.updateRecord(this.$route.params.id, this.$route.params.rid, this.user?.token, itemunflatten)
      }
    },
    async loadCountries() {
      let url = "data-sources/66bca5def254afd9ae336ac8/records";
      let records = await service.getData(url, this.user?.token, { limit: 300 });
      if (records == undefined) return;
      for (let i = 0; i < records?.records?.length; i++) {
        records.records[i].flag = "fi-" + records.records[i].iso_2?.toLowerCase();
      }
      this.countries = records.records;
    },
    async loadPageConfig() {
    
      let category = this.category;
      let template = this.$route.params.id;

      if (this.$route.params.id == "tasks") {
 
        this.template = await service.getConfigurationDetails(template + "/" + this.$route.params.rid, category, this.user?.token);
      } else {
 
        //  if ((category != undefined) && (this.$route.params.id == "raw-products"))
        {
        

          if (this.$route.query.category != undefined) category = this.$route.query.category;

          let response = await service.getConfigurationDetails(template, category, this.user?.token);
      
          this.template = response;
          if (this.$route.params.rid == "new") {
            if (this.$route.query.template != undefined) category = this.$route.query.template;

            let image_id = "66bc4f1658e85d6ca6753171";
             if (this.$route.params?.id=="suppliers-ordering")  image_id = "66aa728ec5234f7b823ccb79"
 
            if (this.template?.default != undefined) {
              let keys = Object.keys(this.template?.default);
              for (let k = 0; k < keys.length; k++) {
                if (keys[k] == "image_id") {
                  image_id = this.template.default[keys[k]];
                  if (image_id == undefined) image_id = "66bc4f1658e85d6ca6753171";
                }
              }
            }
            let record = {};
            record = {
              image_id: image_id,
              "portal-state": "NOT-ACTIVE",
              user_id: null,
            };
            this.record = record;
          }
        }
      }
      return null;
    },
    async loadPageRecord() {
      let category = "";
      let record = {};
      if (this.$route.params.rid == "new") {
        if (this.$route.query.template != undefined) category = this.$route.query.template;
        let image_id = "66bc4f1658e85d6ca6753171";



        if (this.$route.params?.id=="suppliers-ordering")  image_id = "66aa728ec5234f7b823ccb79"
     
        
        if (this.template?.default != undefined) {
          let keys = Object.keys(this.template?.default);
          for (let k = 0; k < keys.length; k++) {
            if (keys[k] == "image_id") {
              image_id = this.template.default[keys[k]];
              if (image_id == undefined) image_id = "66bc4f1658e85d6ca6753171";
            }
          }
        }
        record = {
          image_id: image_id,
          "portal-state": "NOT-ACTIVE",
          user_id: null,
        };
      } else {
        if (this.datasource_id == undefined) {
          // this.$router.push("/error")
          if (this.back) this.$router.push("/error");
          else this.$router.push("/");
          return;
        }
        let collection = "data-sources/" + this.datasource_id + "/records";

        if (this.config?.source_method == "POST") {
          record = await service.postRecord(collection, this.$route.params.rid, this.user?.token);
        } else record = await service.getRecord(collection, this.$route.params.rid, this.user?.token);

        if (record == undefined) {
          let url_default = this.$route.path.replace("/" + this.$route.params.rid, "");
          this.$router.push(url_default);
          return;
        }

        if (record != undefined) category = record.category;
        if (record?.template != undefined) category = record?.template;
        if (category == undefined) category = this.$route.query.template;
      }
      this.category = category;
      this.record = record;
    },
    async onChangeView(item) {
      let url = "/admin/views/" + item.collection + "/" + item.record;
      window.location = url;
    },
  },
};
</script>
<style>
/* Animation d'apparition et disparition */
.toast-enter-active,
.toast-leave-active {
  transition: all 0.5s;
}

.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>
